<template>
    <v-container fluid class="pa-4 wfv2-container">
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
            <v-container style="text-align: center">
                <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
                <p class="pt-2" style="font-size: 14px; color: #234a98">
                    {{ $t('washroomFrequency.loading') }}
                </p>
            </v-container>
        </v-overlay>
        <v-dialog v-model="scelta" max-width="1200" width="95%" persistent v-show="!overlay">
            <v-card class="mb-4" width="100%" flat>
                <v-card-title>
                    {{ $t('washroomFrequency.selectSensor') }}
                </v-card-title>
                <v-card-text>
                    <v-layout class="mt-4" id="makeMeBlue">
                        <v-flex class="px-2">
                            <v-select class="v-select" 
                                v-model="client" 
                                :items="clients" 
                                :label="$t('washroomFrequency.client')"
                                outlined
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                        <v-flex class="px-2">
                            <v-select 
                                v-model="building" 
                                :items="buildings" 
                                :label="$t('washroomFrequency.building')"
                                outlined 
                                :key="b"
                                :disabled="buildingActive"
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                        <v-flex class="px-2">
                            <v-select 
                                v-model="floor" 
                                :items="floors" 
                                :label="$t('washroomFrequency.floor')" 
                                outlined
                                :key="f"
                                :disabled="floorActive"
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                        <v-flex class="px-2">
                            <v-select 
                                v-model="area" 
                                :items="areas" 
                                :label="$t('washroomFrequency.area')"
                                outlined 
                                :key="a"
                                :disabled="areaActive"
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                        <v-flex class="px-2">
                            <v-select 
                                v-model="sensorsValue" 
                                :items="sensor_items" 
                                :label="$t('washroomFrequency.sensor')" 
                                outlined
                                :key="s" 
                                :disabled="sensorActive"
                                :no-data-text="$t('common.noDataAvailable')">
                            </v-select>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="#213A8F" @click="goBack">{{ $t('washroomFrequency.back') }}</v-btn>
                    <v-btn text color="#213A8F" :disabled="okActive" @click="LoadData()">{{ $t('washroomFrequency.ok') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card class="mb-4" width="100%" flat v-show="!scelta && !overlay">
            <v-card-text>
                <v-layout class="mt-4" id="changeMyColor">
                    <v-flex xs6 sm3 md3>
                        <v-select class="v-select" 
                            v-model="client" 
                            :items="clients" 
                            :label="$t('washroomFrequency.client')"
                            outlined
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <v-select class="ml-2" 
                            v-model="building" 
                            :items="buildings" 
                            :label="$t('washroomFrequency.building')" 
                            outlined 
                            :key="b"
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <v-select class="ml-2" 
                            v-model="floor" 
                            :items="floors" 
                            :label="$t('washroomFrequency.floor')" 
                            outlined 
                            :key="f"
                            :disabled="floorActive"
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <v-select class="ml-2" 
                            v-model="area" 
                            :items="areas" 
                            :label="$t('washroomFrequency.area')"
                            outlined 
                            :key="a"
                            :disabled="areaActive"
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <v-select class="ml-2" 
                            v-model="sensorsValue" 
                            :items="sensor_items" 
                            :label="$t('washroomFrequency.sensor')" 
                            outlined
                            :key="s" 
                            :disabled="sensorActive"
                            :no-data-text="$t('common.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm3 md3 class="ml-2">
                        <v-menu ref="menu" 
                            v-model="menu" 
                            :close-on-content-click="false" 
                            :return-value.sync="date"
                            transition="scale-transition" 
                            offset-y 
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field outlined 
                                    v-model="date" 
                                    :label="$t('washroomFrequency.selectDateRange')"
                                    prepend-inner-icon="mdi-calendar" 
                                    readonly 
                                    v-bind="attrs" 
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="date" 
                                no-title 
                                scrollable 
                                :locale="$i18n.locale" 
                                range 
                                :max="maxDate"
                                :min="minDate" 
                                @click="SetMinDate">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu = false">
                                    {{ $t('washroomFrequency.cancel') }}
                                </v-btn>
                                <v-btn text color="primary" @click="handleCalendarOk()">
                                    {{ $t('washroomFrequency.ok') }}
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-card width="100%" flat class="mb-4 wfv2-filter-bar" v-show="!scelta && !overlay">
            <v-card-text>
                <!-- Riga 1: label + bottoni filtri rapidi -->
                <v-row align="center" no-gutters v-show="visualizza_dati && !scelta && !overlay">
                    <v-col cols="auto" class="mr-2" style="white-space:nowrap">
                        <h2 style="font-weight: bold;">{{ $t('washroomFrequency.quickFilters') }}</h2>
                    </v-col>
                    <v-col style="overflow-x:auto; white-space:nowrap; min-width:0">
                        <v-btn text @click="ChangeDate('4h')" class="mt-4 mb-4 mr-0 ml-0">
                            <h2 :style="'color: ' + colore4h">| {{ $t('washroomFrequency.hours') }} |</h2>
                        </v-btn>
                        <v-btn text @click="ChangeDate('1')" class="mt-4 mb-4 mr-0 ml-0">
                            <h2 :style="'color: ' + colore1d">| {{ $t('washroomFrequency.day') }} |</h2>
                        </v-btn>
                        <v-btn text @click="ChangeDate('7')" class="mt-4 mb-4 mr-0 ml-0">
                            <h2 :style="'color: ' + colore1w">| {{ $t('washroomFrequency.week') }} |</h2>
                        </v-btn>
                        <v-btn text @click="ChangeDate('14')" class="mt-4 mb-4 mr-0 ml-0">
                            <h2 :style="'color: ' + colore2w">| {{ $t('washroomFrequency.twoWeeks') }} |</h2>
                        </v-btn>
                        <v-btn text @click="ChangeDate('30')" class="mt-4 mb-4 mr-0 ml-0">
                            <h2 :style="'color: ' + colore3d">| {{ $t('washroomFrequency.thirtyDays') }} |</h2>
                        </v-btn>
                    </v-col>
                </v-row>
                <!-- Riga 2: toggle "Includi weekend" sempre su riga dedicata -->
                <v-row align="center" no-gutters v-show="visualizza_dati && !scelta && !overlay" class="mt-1">
                    <v-spacer />
                    <v-col cols="auto" class="d-flex align-center">
                        <span class="mr-2" style="font-size:14px; color:#213A8F">{{ $t('smartDispenser.includeWeekends') }}</span>
                        <v-switch v-model="includeWeekends" color="#213A8F" dense hide-details inset class="mt-0 pt-0" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="mt-4" height="100%" flat style="background:transparent" v-if="visualizza_dati && !scelta">
            <v-card-text>

                <!-- ── SENSOR OVERVIEW + CURRENT TRAFFIC (V2) ── -->
                <v-row class="mb-4" align="stretch">

                  <!-- Sensor Overview -->
                  <v-col cols="12" md="6" style="display:flex">
                    <v-card outlined class="pa-4 wfv2-card" style="width:100%">
                      <div class="d-flex align-center mb-2">
                        <span class="wfv2-overline mr-2">{{ $t('washroomFrequency.sensorOverview').toUpperCase() }}</span>
                        <v-chip x-small :color="statusChipColor" :text-color="statusChipTextColor" class="wfv2-badge">
                          <v-icon x-small left>mdi-circle</v-icon>
                          {{ isOnline ? $t('washroomFrequency.online') : $t('washroomFrequency.offline') }}
                        </v-chip>
                      </div>
                      <div class="wfv2-sensor-name mb-1">{{ sensor_name }}</div>
                      <div class="caption wfv2-muted mb-1" v-if="locationBreadcrumb">
                        <v-icon x-small class="mr-1">mdi-map-marker-outline</v-icon>{{ locationBreadcrumb }}
                      </div>
                      <div class="caption wfv2-muted mb-3" v-if="translatedSensorType">
                        <v-icon x-small class="mr-1">mdi-access-point</v-icon>{{ translatedSensorType }}
                      </div>
                      <v-row dense>
                        <v-col cols="4">
                          <v-card outlined class="wfv2-info-tile pa-3">
                            <div class="d-flex justify-space-between align-start">
                              <div class="caption wfv2-muted">{{ $t('washroomFrequency.lastDataReceivedLabel') }}</div>
                              <v-icon small color="#213A8F">mdi-wifi</v-icon>
                            </div>
                            <div class="wfv2-info-value mt-2">{{ formattedLastDataReceived }}</div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card outlined class="wfv2-info-tile pa-3">
                            <div class="d-flex justify-space-between align-start">
                              <div class="caption wfv2-muted">{{ $t('washroomFrequency.lastCleaningLabel') }}</div>
                              <v-icon small color="#213A8F">mdi-broom</v-icon>
                            </div>
                            <div class="wfv2-info-value mt-2">{{ lastManagedDisplay }}</div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card outlined class="wfv2-info-tile pa-3">
                            <div class="d-flex justify-space-between align-start">
                              <div class="caption wfv2-muted">{{ $t('washroomFrequency.alertThresholdLabel') }}</div>
                              <v-icon small color="orange darken-1">mdi-bell-outline</v-icon>
                            </div>
                            <div class="wfv2-info-value mt-2">{{ adjustedAlertThreshold || '–' }} {{ $t('washroomFrequency.entriesUnit') }}</div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <!-- Current Traffic -->
                  <v-col cols="12" md="6" style="display:flex">
                    <v-card outlined class="pa-4 wfv2-card" style="width:100%">
                      <div class="d-flex justify-space-between align-center mb-2">
                        <span class="wfv2-overline">{{ $t('washroomFrequency.currentTrafficTitle').toUpperCase() }}</span>
                        <div class="d-flex align-center" style="gap:6px">
                          <v-chip x-small
                            :color="isAboveThresholdTraffic ? '#FFEBEE' : '#E8F5E9'"
                            :text-color="isAboveThresholdTraffic ? '#C62828' : '#2E7D32'"
                            class="wfv2-badge">
                            {{ isAboveThresholdTraffic ? $t('washroomFrequency.aboveThreshold') : $t('washroomFrequency.belowThreshold') }}
                          </v-chip>
                          <v-icon small color="#BFCCE4">mdi-wifi</v-icon>
                        </div>
                      </div>
                      <div class="wfv2-level-pct mb-3">{{ adjustedCurrentTraffic !== null ? adjustedCurrentTraffic : '–' }}</div>

                      <!-- Traffic bar -->
                      <div class="wfv2-bar-wrapper mb-2">
                        <div class="wfv2-bar-threshold-label" :style="{ left: clampPct(trafficThresholdPct, 5, 88) + '%' }">
                          {{ $t('washroomFrequency.thresholdLabel') }} {{ adjustedAlertThreshold }}
                        </div>
                        <div class="wfv2-bar">
                          <div class="wfv2-bar-fill" :style="{ width: clampPct(trafficFillPct, 0, 100) + '%' }">
                            <span v-if="trafficFillPct > 10" class="wfv2-bar-fill-label">{{ adjustedCurrentTraffic }}</span>
                          </div>
                          <div class="wfv2-bar-marker" :style="{ left: trafficThresholdPct + '%' }" />
                        </div>
                      </div>

                      <!-- Legend -->
                      <div class="d-flex align-center wfv2-legend">
                        <span class="wfv2-legend-dot" style="background:#009CAB" />
                        <span class="caption mr-3">{{ $t('washroomFrequency.trafficLegend') }}</span>
                        <span class="wfv2-legend-line" />
                        <span class="caption mr-3">{{ $t('washroomFrequency.thresholdLegend') }}</span>
                        <span class="wfv2-legend-dot" style="background:#BFCCE4" />
                        <span class="caption">{{ $t('washroomFrequency.remainingRange') }}</span>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- ── KPI CARDS ── -->
                <v-row dense class="mb-5">

                  <!-- 1. Avg Daily Traffic -->
                  <v-col cols="6" sm="4" md="2">
                    <v-card flat class="wfv2-kpi-card pa-3">
                      <div class="wfv2-kpi-icon"><v-icon color="#213A8F">mdi-chart-bar</v-icon></div>
                      <div class="wfv2-kpi-label">{{ $t('washroomFrequency.avgDailyTrafficKpi') }}</div>
                      <div class="wfv2-kpi-value">{{ adjustedAverageDailyTraffic || '–' }}</div>
                      <div class="wfv2-kpi-sub">{{ $t('washroomFrequency.averageEntriesPerDay') }}</div>
                    </v-card>
                  </v-col>

                  <!-- 2. Peak Traffic Window -->
                  <v-col cols="6" sm="4" md="2">
                    <v-card flat class="wfv2-kpi-card pa-3">
                      <div class="wfv2-kpi-icon"><v-icon color="#213A8F">mdi-clock-outline</v-icon></div>
                      <div class="wfv2-kpi-label">{{ $t('washroomFrequency.peakTrafficWindow') }}</div>
                      <div class="wfv2-kpi-value wfv2-kpi-value-sm">{{ peakTrafficWindowLabel }}</div>
                      <div class="wfv2-kpi-sub">{{ peakTrafficWindowEntries }} {{ $t('washroomFrequency.entriesUnit') }}</div>
                    </v-card>
                  </v-col>

                  <!-- 3. Avg Daily Cleaning Activities -->
                  <v-col cols="6" sm="4" md="2">
                    <v-card flat class="wfv2-kpi-card pa-3">
                      <div class="wfv2-kpi-icon"><v-icon color="#213A8F">mdi-broom</v-icon></div>
                      <div class="wfv2-kpi-label">{{ $t('washroomFrequency.avgDailyCleaningActivities') }}</div>
                      <div class="wfv2-kpi-value">{{ avgDailyCleaningActivities }}</div>
                      <div class="wfv2-kpi-sub">{{ $t('washroomFrequency.validatedOperationsPerDay') }}</div>
                    </v-card>
                  </v-col>

                  <!-- 4. Avg Traffic per Cleaning -->
                  <v-col cols="6" sm="4" md="2">
                    <v-card flat class="wfv2-kpi-card pa-3">
                      <div class="wfv2-kpi-icon"><v-icon color="#213A8F">mdi-counter</v-icon></div>
                      <div class="wfv2-kpi-label">{{ $t('washroomFrequency.avgTrafficPerCleaning') }}</div>
                      <div class="wfv2-kpi-value">{{ avgTrafficPerCleaning }}</div>
                      <div class="wfv2-kpi-sub">{{ $t('washroomFrequency.entriesPerCleaning') }}</div>
                    </v-card>
                  </v-col>

                  <!-- 5. Avg Daily Alerts -->
                  <v-col cols="6" sm="4" md="2">
                    <v-card flat class="wfv2-kpi-card pa-3">
                      <div class="wfv2-kpi-icon"><v-icon color="orange darken-1">mdi-alert-circle-outline</v-icon></div>
                      <div class="wfv2-kpi-label">{{ $t('washroomFrequency.avgDailyAlertsKpi') }}</div>
                      <div class="wfv2-kpi-value">{{ averageDailyAlertsPeriodDisplay }}</div>
                      <div class="wfv2-kpi-sub">{{ $t('washroomFrequency.thresholdExceedancesPerDay') }}</div>
                    </v-card>
                  </v-col>

                  <!-- 6. Avg Active Hours / Day -->
                  <v-col cols="6" sm="4" md="2">
                    <v-card flat class="wfv2-kpi-card pa-3">
                      <div class="wfv2-kpi-icon"><v-icon color="#213A8F">mdi-clock-check-outline</v-icon></div>
                      <div class="wfv2-kpi-label">{{ $t('washroomFrequency.avgActiveHoursPerDay') }}</div>
                      <div class="wfv2-kpi-value">{{ avgActiveHoursPerDay }}</div>
                      <div class="wfv2-kpi-sub">{{ $t('washroomFrequency.hoursWithRecordedTraffic') }}</div>
                    </v-card>
                  </v-col>
                </v-row>

                <hr style="border-top:1px solid #BFCCE4" class="mb-4" />
                <!-- <v-layout class="mt-4 mr-4 mb-4 ml-4">
              <v-flex xs12 sm12 md12>
                      <v-card class="mt-4 mr-4 mb-4 ml-4" height="100%" flat>
                          <v-card-title> -->
                <!-- <v-layout> -->
                <!-- <v-flex xs12 sm12 md3>
                                  <v-select
                                  v-model="displayed_range"
                                  :items="to_display"
                                  label="Select displayed range"
                                  >
                                  </v-select>
                              </v-flex> -->
                <!-- <v-flex xs12 sm12 md12>
                              
                          </v-flex>
                          </v-layout>
                          </v-card-title>
                          <v-card-text>
                              <h2 style="margin-top: 15px; font-weight: bold;  color: #234a98 !important" >BIN LEVEL </h2>
                              <apexchartComponent type="line" height="350" :options="chartOptions_bin" :series="series_dispenser" />
                          </v-card-text>
                          <v-card-actions>
  
                          </v-card-actions>
                      </v-card>
                      </v-flex>
                  
              </v-layout> -->
                <v-row class="mb-4">
                    <v-col cols="12">
                        <v-card class="pa-4 wfv2-chart-card" flat>
                            <h3 style="color:#213A8F" class="mb-3">{{ $t('washroomFrequency.washroomUsageFrequency') }}</h3>
                            <v-card-text style="min-height: 350px;">
                                <apexchartComponent v-if="hasBinChartData" type="bar" height="350"
                                    :options="chartOptions_bin" :series="series_dispenser"
                                    :key="'bin-' + keyStacked + '-' + (series_dispenser[0] && series_dispenser[0].data ? series_dispenser[0].data.length : 0)" />
                                <div v-else class="text-center grey--text" style="padding: 2rem;">
                                    {{ $t('washroomFrequency.loadingChart') || 'Caricamento grafico...' }}
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row class="mb-4" v-show="visualizza_dati && !scelta && isAdminOrSuperAdmin">
                    <v-col cols="12">
                        <v-card class="pa-4 wfv2-chart-card" flat>
                            <h3 style="color:#213A8F" class="mb-3">{{ $t('washroomFrequency.trafficVolumeVsAlert') }}</h3>
                            <apexchartComponent type="bar" height="350" :options="chartOptions_alert"
                                :series="series_alert" :key="keyAlert" />
                        </v-card>
                    </v-col>
                </v-row>

                <!-- Grafico timeline con alert e pulizie (solo per aggregazione oraria) -->
                <v-row class="mb-4" v-show="visualizza_dati && !scelta && isAdminOrSuperAdmin && showTimelineGraph">
                    <v-col cols="12">
                        <v-card class="pa-4 wfv2-chart-card" flat>
                            <h3 style="color:#213A8F" class="mb-3">{{ $t('washroomFrequency.serviceEfficiencyTimeline') }}</h3>
                            <apexchartComponent type="area" height="400" :options="chartOptions_timeline"
                                :series="series_timeline" :key="keyTimeline" />
                        </v-card>
                    </v-col>
                </v-row>
                <v-row class="mb-4">
                    <v-col cols="12">
                        <v-card class="pa-4 wfv2-chart-card" flat>
                            <h3 style="color:#213A8F" class="mb-3">{{ $t('washroomFrequency.usageByDaytime') }}</h3>
                            <apexchartComponent type="bar" height="400" :options="chartOptions_daytime"
                                :series="series_daytime" :key="keyDaytime" />
                        </v-card>
                    </v-col>
                </v-row>
                <v-row class="mb-4">
                    <v-col cols="12">
                        <v-card class="pa-4 wfv2-chart-card" flat>
                            <h3 style="color:#213A8F" class="mb-3">{{ $t('washroomFrequency.usageByFourHourly') }}</h3>
                            <apexchartComponent type="bar" height="400" :options="chartOptions_fourhourly"
                                :series="series_fourhourly" :key="keyFourHourly" />
                        </v-card>
                    </v-col>
                </v-row>
                <!-- <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4"/> -->
                <!-- <v-layout class="mt-4 mr-4 mb-4 ml-4">
                      <v-flex xs12 sm12 md12>
                      <v-card class="mt-4 mr-4 mb-4 ml-4" height="100%" flat>
                          <v-card-text>
                              <h2 style="margin-top: 15px; font-weight: bold; color: #234a98 !important" >FULL HOUR(S) </h2>
                              <apexchartComponent max-width="20%" type="bar" height="350" :options="chartOptions_bar" :series="series_bar" :key="keyBar" />
                          </v-card-text>
                      </v-card>
                      </v-flex>
                  </v-layout> -->

            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import axios from "axios";
import { addPeriodSubtitleToChartOptions, getChartSubtitleConfig } from "@/utils/chartPeriodFormatter";
import { applyDoorCountFloor } from "@/utils/sensorUtils";
import {
    formatDateDisplay,
    formatDateTimeDisplay,
    formatTimeDisplay,
    toBackendDate,
    toBackendDateTime,
} from '@/utils/dateTimezone';
import { applyTimezoneToApexCharts } from '@/utils/chartDateFormatter';

export default {
    name: 'WashroomFrequencyV2',
    data() {
        return {
            isLoadingFromRoute: false, // Flag per evitare interferenze dei watcher durante il caricamento dalla route
            maxDate: "",
            minDate: "",
            currentStartDate: null, // Data inizio periodo corrente per sottotitoli grafici
            currentEndDate: null,   // Data fine periodo corrente per sottotitoli grafici
            cleaning_state: '',
            last_managed: '',
            alert_threshold: '',
            dayli: 0,
            sensorDataRequestId: 0, // Token per annullare risposte obsolete (race condition)
            scelta: true,
            visualizza_dati: false,
            sensor_img: "",
            sensorActive: true,
            floorActive: true,
            i: 0,
            b: 0,
            s: 0,
            f: 0,
            a: 0,
            includeWeekends: true,
            currentPeriod: '1',
            rawStackedData: [],
            colore4h: "#DAE0EC",
            index4h: 0,
            colore1d: "#DAE0EC",
            colore3d: "#DAE0EC",
            colore1w: "#DAE0EC",
            colore2w: "#DAE0EC",
            colore_stato: "",
            overlay: false,
            building_name: "",
            floor_name: "",
            level_status: 0,
            last_refill: "2023-02-01",
            GiornoSettimana: '',
            OraSensore: '',
            DataSensore: '',
            keyBar: 0,
            keyStacked: 0,
            keyDaytime: 0,
            keyFourHourly: 0,
            radialKey: 0,
            sensor_name: "",
            // Nuovi campi per TRAFFIC OVERVIEW / CURRENT TRAFFIC
            sensor_type: '',
            averageAlerts: null,
            averageDailyTraffic: null,
            averageDailyAlertsPeriod: null, // Alert medi giornalieri per il periodo selezionato
            currentTraffic: null,
            currentTime: '',
            series_daytime: [],
            series_fourhourly: [],
            series_alert: [], // Nuova serie per il grafico alert
            keyAlert: 0, // Chiave per forzare il re-render del grafico alert
            series_timeline: [], // Nuova serie per il grafico timeline
            keyTimeline: 0, // Chiave per forzare il re-render del grafico timeline
            showTimelineGraph: false, // Flag per mostrare il grafico timeline solo con aggregazione oraria
            lastTimelineData: null, // Salva i dati per il re-render del timeline
            lastTimelineStart: null, // Salva start date per il re-render
            lastTimelineEnd: null, // Salva end date per il re-render
            colors: "#18ff00",
            series_punctual: [],
            PunctualchartOptions: {
                colors: [
                    "#009CAB",
                    "#dae0ec",
                ],
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                chart: {
                    type: 'bar',
                    stacked: true,
                    //stackType: "100%",
                    offsetY: -20,
                    sparkline: {
                        enabled: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, { seriesIndex, dataPointIndex, w }) {
                        dataPointIndex;
                        if (w.config.series[seriesIndex].name != 'Empty')
                            return val
                        else
                            return ''
                    },
                },
                xaxis: {

                    min: 0,
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#BFCCE4',
                        },
                    },
                    axisTicks: {
                        colors: '#BFCCE4',
                    },
                },
                plotOptions: {
                    states: {
                        hover: {
                            filter: {
                                type: 'none',
                                value: 0,
                            }
                        }
                    },
                    bar: {
                        borderRadius: 4,
                        columnWidth: '100%',
                        horizontal: true,
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            background: "#e7e7e7",
                            strokeWidth: '97%',
                            margin: 5, // margin is in pixels
                            dropShadow: {
                                enabled: true,
                                top: 2,
                                left: 0,
                                color: '#999',
                                opacity: 1,
                                blur: 2
                            }
                        },
                    },
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: "horizontal",
                        shadeIntensity: 0.5,
                        inverseColors: true,
                        gradientToColors: ['#213A8F'],
                        gradientFromColors: ['#009CAB'],
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    },
                },
            },



            handPaperRolls: 0,
            foldedTowels: 0,
            users: 0,
            averageUsers: 0,
            menu: false,
            date: [],
            floor_items: [],
            floorValue: "",
            buildingValue: [],
            lista_bin: [],
            lista_stacked: [],
            valueBin: [],
            valueStacked: [],
            valueBar: [],
            valueVuoto: [],
            valueRotoli: [],
            valueDispenser: [],
            dialogBar: false,
            dialogBin: false,
            dialogStacked: false,
            dialogVuoto: false,
            dialogRotoli: false,
            dialogDispenser: false,
            building_items: [],
            series_bin: [],
            series_stacked: [],
            series_bar: [],
            series_dispenser: [],
            series_rotoli: [],
            series_vuoto: [],
            sensor_unique: '',
            chartOptions_bin: {
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        distributed: true
                    },
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                colors: ['#BFCCE4'],
                dropShadow: {
                    enabled: false,
                    enabledOnSeries: undefined,
                    top: 0,
                    left: 0,
                    blur: 3,
                    color: '#000',
                    opacity: 0.35
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    type: 'line',
                    height: 700,
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        show: false,
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                yaxis: {
                    min: 0,


                    labels: {
                        offset: 10,
                        style: {
                            colors: '#BFCCE4',
                        },
                        formatter: function (value) {
                            return Number(value).toFixed(0);
                        },
                    }
                },
                xaxis: {
                    colors: '#213A8F',
                    categories: [],
                    labels: {
                        style: {
                            colors: '#213A8F',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                fill: {
                    opacity: 1
                },
                legend: {
                    show: false,
                    position: 'right',
                    offsetX: 0,
                    offsetY: 50
                },
            },
            
            // Nuovo grafico timeline per visualizzazione eventi con alert e pulizie
            chartOptions_timeline: {
                chart: {
                    type: 'area',
                    height: 400,
                    toolbar: {
                        show: false,
                    },
                    animations: {
                        enabled: true
                    }
                },
                stroke: {
                    curve: 'smooth',
                    width: 3,
                    colors: ['#213A8F']
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.4,
                        opacityTo: 0.1,
                        stops: [0, 90, 100]
                    },
                    colors: ['#213A8F']
                },
                colors: ['#213A8F'],
                dataLabels: {
                    enabled: false
                },
                markers: {
                    size: 4,
                    colors: ['#213A8F'],
                    strokeColors: '#fff',
                    strokeWidth: 2,
                    hover: {
                        size: 7
                    }
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        datetimeUTC: false,
                        format: 'HH:mm',
                        style: {
                            colors: '#213A8F',
                            fontSize: '10px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: 'Events',
                        style: {
                            color: '#213A8F',
                            fontSize: '12px',
                            fontWeight: 600
                        }
                    },
                    labels: {
                        style: {
                            colors: '#BFCCE4'
                        },
                        formatter: function (value) {
                            return Number(value).toFixed(0);
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    x: {
                        format: 'dd/MM HH:mm'
                    }
                },
                annotations: {
                    xaxis: [],
                    points: []
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['transparent', 'transparent'],
                        opacity: 0.5
                    }
                },
                legend: {
                    show: true,
                    position: 'top',
                    horizontalAlign: 'left',
                    labels: {
                        colors: '#213A8F'
                    }
                }
            },
            
            // Nuovo grafico per visualizzazione con/senza alert
            chartOptions_alert: {
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        distributed: false
                    },
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                colors: ['#213A8F', '#ff914d'], // Blu scuro per "without alert", arancione per "during alert"
                chart: {
                    toolbar: {
                        show: false,
                    },
                    type: 'bar',
                    height: 350,
                    stacked: true,
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                yaxis: {
                    min: 0,
                    labels: {
                        offset: 10,
                        style: {
                            colors: '#BFCCE4',
                        },
                        formatter: function (value) {
                            return Number(value).toFixed(0);
                        },
                    }
                },
                xaxis: {
                    colors: '#213A8F',
                    categories: [],
                    labels: {
                        style: {
                            colors: '#213A8F',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                fill: {
                    opacity: 1
                },
                legend: {
                    show: true,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    labels: {
                        colors: '#213A8F',
                    },
                    fontSize: '12px',
                    fontWeight: 600
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '11px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 'normal',
                        colors: ['#FFFFFF', '#FFFFFF']
                    },
                    formatter: function (val) {
                        return val > 0 ? val : '';
                    },
                    background: {
                        enabled: false
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 1,
                        color: '#000',
                        opacity: 0.45
                    }
                },
            },
            
            chartOptions_daytime: {
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        minBarHeight: 8
                    },
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    type: 'bar',
                    height: 400,
                    stacked: true
                },
                yaxis: {
                    labels: {
                        offset: 10,
                        style: {
                            colors: '#BFCCE4',
                        },
                        formatter: function (value) {
                            return Number(value).toFixed(0);
                        },
                    }
                },
                xaxis: {
                    colors: '#213A8F',
                    categories: [],
                    labels: {
                        style: {
                            colors: '#213A8F',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                fill: {
                    colors: ['#BFCCE4', '#213A8F'],
                    opacity: 1
                },
                legend: {
                    show: true,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    labels: {
                        colors: '#213A8F',
                    },
                    fontSize: '12px',
                    fontWeight: 600
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '11px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 'normal',
                        colors: ['#FFFFFF']
                    },
                    formatter: function (val) {
                        return val > 0 ? val : '';
                    },
                    background: {
                        enabled: false
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 1,
                        color: '#000',
                        opacity: 0.45
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (val, { dataPointIndex, w }) {
                            const series = w.config.series;
                            let total = 0;
                            series.forEach(s => {
                                total += s.data[dataPointIndex] || 0;
                            });
                            const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                            return val + " events (" + percentage + "%)";
                        }
                    }
                }
            },

            chartOptions_fourhourly: {
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        minBarHeight: 8
                    },
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    type: 'bar',
                    height: 400,
                    stacked: true
                },
                yaxis: {
                    labels: {
                        offset: 10,
                        style: {
                            colors: '#BFCCE4',
                        },
                        formatter: function (value) {
                            return Number(value).toFixed(0);
                        },
                    }
                },
                xaxis: {
                    colors: '#213A8F',
                    categories: [],
                    labels: {
                        style: {
                            colors: '#213A8F',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                fill: {
                    colors: ['#DAE0EC', '#C3D4E8', '#9FB7D8', '#7B9AC8', '#577DB8', '#213A8F'],
                    opacity: 1
                },
                legend: {
                    show: true,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    labels: {
                        colors: '#213A8F',
                    },
                    fontSize: '12px',
                    fontWeight: 600
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '11px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 'normal',
                        colors: ['#000000']
                    },
                    formatter: function (val) {
                        return val > 0 ? val : '';
                    },
                    background: {
                        enabled: false
                    },
                    dropShadow: {
                        enabled: false
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (val, { dataPointIndex, w }) {
                            const series = w.config.series;
                            let total = 0;
                            series.forEach(s => {
                                total += s.data[dataPointIndex] || 0;
                            });
                            const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                            return val + " events (" + percentage + "%)";
                        }
                    }
                }
            },

            chartOptions_stacked: {
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        distributed: true
                    },
                },
                colors: ['#008ffb'],
                chart: {

                    toolbar: {
                        show: false,
                    },
                    type: 'bar',
                    height: 350,
                    // stacked: true,
                    // stackType: '100%'
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#BFCCE4',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                xaxis: {
                    categories: ['01/09/2022', '02/09/2022', '03/09/2022', '04/09/2022', '05/09/2022', '06/09/2022',
                        '07/09/2022', '08/09/2022'
                    ],
                    labels: {
                        style: {
                            colors: '#213A8F',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                fill: {
                    colors: ['#BFCCE4'],
                    opacity: 1
                },
                legend: {
                    show: false,
                },
                title: {
                    text: "",
                    rotate: -90,
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title',
                    },
                }
            },
            crosshairs: {
            },
            chartOptions_bar: {
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        distributed: true
                    },
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                fill: {
                    colors: ['#BFCCE4']
                },
                stroke: {
                    curve: 'straight'
                },
                legend: {
                    show: false,
                },
                xaxis: {
                    categories: [],
                    labels: {
                        style: {
                            colors: '#213A8F',
                            fontSize: '8px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                            legend: {
                                show: false,
                            },
                        },
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#BFCCE4',
                        },
                    },
                },
                colors: '#BFCCE4',
            },
            sensor_id: "",
            sensor_id_numeric: null, // ID numerico del sensore per le API
            sensor_items: [],
            sensorsValue: "",
            okActive: true,
            minValue: 0,
            maxValue: 0,
            client: "",
            clients: [],
            buildingActive: true,
            areaActive: true,
            building: "",
            buildings: [],
            floor: "",
            floors: [],
            area: "",
            areas: [],
            sensorAlerts: [], // Array per memorizzare gli alert del sensore
            cleanerScanEvents: [],   // Eventi CLEANER_SCAN nel periodo selezionato (per KPI e grafico)
            lastCleanerScanDate: null, // Timestamp più recente di CLEANER_SCAN (senza filtro data, per il box display)
            rawDailyTrafficData: [], // Dati giornalieri grezzi { date, traffic } per KPI con filtro weekend
            rawHourlyActivityData: [], // Ore attive per giorno { date, activeHours } calcolate da dati grezzi
            rawFourhourlyCategories: [], // Date colonne fourhourly per filtro weekend
        }
    },
    computed: {
        isAdminOrSuperAdmin() {
            // Verifica se il ruolo dell'utente è Admin, Youtissue Admin, Client o Facility Manager
            const userRole = this.$store.state.userRole;
            console.log('User role from computed:', userRole);
            
            // userRole è un array di oggetti con proprietà Name
            if (Array.isArray(userRole) && userRole.length > 0) {
                const roleName = userRole[0].Name;
                console.log('Role Name:', roleName);
                return roleName === 'Admin' || roleName === 'Youtissue Admin' || roleName === 'Client' || roleName === 'Facility Manager';
            }
            
            return false;
        },
        
        translatedSensorType() {
            // Traduce il tipo di sensore in base alla lingua corrente
            if (!this.sensor_type) return '-';
            
            // Verifica se esiste una traduzione per questo tipo di sensore
            const translationKey = `washroomFrequency.sensorTypes.${this.sensor_type}`;
            const translated = this.$t(translationKey);
            
            // Se la traduzione esiste (non restituisce la chiave), usala; altrimenti usa il valore originale
            if (translated && translated !== translationKey) {
                return translated;
            }
            
            return this.sensor_type;
        },
        
        // Computed properties per applicare l'aggiustamento Door Counter ai valori visualizzati
        adjustedAverageAlerts() {
            return this.applyDoorCounterAdjustment(this.averageAlerts);
        },
        
        adjustedAverageDailyTraffic() {
            const days = this.effectivePeriodDays;
            if (!days) return 0;
            return Math.round(this.effectiveTotalTraffic / days);
        },
        
        adjustedCurrentTraffic() {
            // PartialCount NON deve essere dimezzato per Door Counter
            // Arrotonda per difetto se non è intero
            if (this.currentTraffic === null || this.currentTraffic === undefined) {
                return this.currentTraffic;
            }
            return Math.floor(this.currentTraffic);
        },
        
        adjustedAlertThreshold() {
            // AlertValue NON deve essere dimezzato per Door Counter
            return this.alert_threshold;
        },
        averageDailyAlertsPeriodDisplay() {
            if (!this.sensorAlerts || !this.currentStartDate || !this.currentEndDate) {
                if (this.averageDailyAlertsPeriod === null || this.averageDailyAlertsPeriod === undefined) return '-';
                return Number(this.averageDailyAlertsPeriod).toFixed(2);
            }
            const days = this.effectivePeriodDays;
            if (!days) return '-';
            const startDate = new Date(this.currentStartDate.substr(0, 10));
            const endDate = new Date(this.currentEndDate.substr(0, 10));
            endDate.setDate(endDate.getDate() + 1);
            let count = 0;
            this.sensorAlerts.forEach(alert => {
                const alertDate = new Date(alert.Timestamp);
                if (alertDate >= startDate && alertDate < endDate) {
                    if (this.includeWeekends || (alertDate.getDay() !== 0 && alertDate.getDay() !== 6)) {
                        count++;
                    }
                }
            });
            return (count / days).toFixed(2);
        },
        /** Data/ora ultima pulizia: il più recente tra gestione alert e CLEANER_SCAN.
         *  Usa lastCleanerScanDate (indipendente dal periodo) per non perdere pulizie fuori range. */
        lastManagedDisplay() {
            const tz = this.$store.state.timezone || 'Europe/Rome';

            // Data da gestione alert (URL_LASTMANAGED)
            let dateAlert = null;
            if (this.last_managed) {
                const s = String(this.last_managed).trim();
                if (s.indexOf('0000-00-00') !== 0) {
                    dateAlert = this.parseDateSafe(s);
                }
            }

            // Data più recente da CLEANER_SCAN (senza filtro data, sempre aggiornata)
            const dateClean = this.lastCleanerScanDate
                ? this.parseDateSafe(String(this.lastCleanerScanDate))
                : null;

            // Prendi il più recente tra i due
            let best = null;
            if (dateAlert && dateClean) best = dateAlert > dateClean ? dateAlert : dateClean;
            else best = dateAlert || dateClean;

            if (!best) return '-';
            return formatDateTimeDisplay(best.toISOString(), tz) || '-';
        },
        /** True solo quando il grafico bin ha serie e categorie popolate (evita render a vuoto). */
        hasBinChartData() {
            if (!this.series_dispenser || this.series_dispenser.length === 0) return false;
            const s0 = this.series_dispenser[0];
            if (!s0 || !Array.isArray(s0.data) || s0.data.length === 0) return false;
            const cat = this.chartOptions_bin && this.chartOptions_bin.xaxis && this.chartOptions_bin.xaxis.categories;
            return Array.isArray(cat) && cat.length > 0;
        },

        // ── V2 Overview computed ──────────────────────────────────────────────

        isOnline() {
            return this.colore_stato !== '' && this.colore_stato !== 'grey';
        },
        statusChipColor() {
            if (!this.isOnline) return '#EEEEEE';
            return '#E8F5E9';
        },
        statusChipTextColor() {
            if (!this.isOnline) return '#757575';
            return '#2E7D32';
        },
        locationBreadcrumb() {
            const clientName = (this.clients.find(c => c.value === this.client) || {}).text || '';
            const areaName = (this.areas.find(a => a.value === this.area) || {}).text || '';
            return [clientName, this.building_name, this.floor_name, areaName].filter(Boolean).join(' · ');
        },
        formattedLastDataReceived() {
            if (!this.DataSensore) return '–';
            return this.OraSensore ? `${this.DataSensore} · ${this.OraSensore}` : this.DataSensore;
        },
        isAboveThresholdTraffic() {
            return (this.adjustedCurrentTraffic || 0) >= (this.adjustedAlertThreshold || 1);
        },

        // ── Traffic bar helpers ───────────────────────────────────────────────

        trafficBarMaxValue() {
            const traffic = this.adjustedCurrentTraffic || 0;
            const threshold = this.adjustedAlertThreshold || 1;
            return Math.max(traffic, threshold) * 1.15;
        },
        trafficFillPct() {
            if (!this.trafficBarMaxValue) return 0;
            return Math.min(100, ((this.adjustedCurrentTraffic || 0) / this.trafficBarMaxValue) * 100);
        },
        trafficThresholdPct() {
            if (!this.trafficBarMaxValue) return 0;
            return Math.min(95, ((this.adjustedAlertThreshold || 0) / this.trafficBarMaxValue) * 100);
        },

        // ── Weekend-filter helpers ───────────────────────────────────────────

        /** Numero di giorni lavorativi nel periodo (esclude sabato/domenica se !includeWeekends). */
        effectivePeriodDays() {
            if (this.includeWeekends) return this.currentPeriodDays;
            if (!this.currentStartDate || !this.currentEndDate) return 1;
            let count = 0;
            const s = new Date(this.currentStartDate.substr(0, 10));
            const e = new Date(this.currentEndDate.substr(0, 10));
            const d = new Date(s);
            while (d <= e) {
                const dow = d.getDay();
                if (dow !== 0 && dow !== 6) count++;
                d.setDate(d.getDate() + 1);
            }
            return Math.max(1, count);
        },
        /** Traffico totale nel periodo, con eventuale esclusione dei weekend. */
        effectiveTotalTraffic() {
            if (this.rawDailyTrafficData && this.rawDailyTrafficData.length > 0) {
                return this.rawDailyTrafficData
                    .filter(d => {
                        if (this.includeWeekends) return true;
                        const dow = new Date(d.date).getDay();
                        return dow !== 0 && dow !== 6;
                    })
                    .reduce((acc, d) => acc + (d.traffic || 0), 0);
            }
            const data = this.series_dispenser && this.series_dispenser[0] ? this.series_dispenser[0].data : [];
            return data.reduce((acc, v) => acc + (v || 0), 0);
        },
        /** Eventi di pulizia filtrati: esclude i weekend se !includeWeekends. */
        effectiveCleanerEvents() {
            if (!this.cleanerScanEvents) return [];
            if (this.includeWeekends) return this.cleanerScanEvents;
            return this.cleanerScanEvents.filter(event => {
                const ts = event.typeSpecificProps?.timestamp || event.timestamp || event.createdAt;
                if (!ts) return true;
                const d = new Date(String(ts));
                if (isNaN(d.getTime())) return true;
                const dow = d.getDay();
                return dow !== 0 && dow !== 6;
            });
        },
        /** Serie fourhourly filtrate per i KPI: rimuove colonne weekend se !includeWeekends. */
        effectiveFourhourlyData() {
            if (!this.series_fourhourly || this.series_fourhourly.length < 6) return this.series_fourhourly;
            if (this.includeWeekends) return this.series_fourhourly;
            const cats = this.rawFourhourlyCategories;
            if (!cats || !cats.length) return this.series_fourhourly;
            const weekdayIndices = cats
                .map((date, idx) => ({ date, idx }))
                .filter(({ date }) => {
                    const dow = new Date(date).getDay();
                    return dow !== 0 && dow !== 6;
                })
                .map(({ idx }) => idx);
            if (!weekdayIndices.length) return this.series_fourhourly;
            return this.series_fourhourly.map(serie => ({
                ...serie,
                data: weekdayIndices.map(i => (serie.data || [])[i] || 0),
            }));
        },

        // ── KPI cards ────────────────────────────────────────────────────────

        currentPeriodDays() {
            if (!this.currentStartDate || !this.currentEndDate) return 1;
            const s = new Date(this.currentStartDate.substr(0, 10));
            const e = new Date(this.currentEndDate.substr(0, 10));
            return Math.max(1, Math.round((e - s) / 86400000) + 1);
        },
        peakTrafficWindowLabel() {
            const fourhourly = this.effectiveFourhourlyData;
            if (!fourhourly || fourhourly.length < 6) return '–';
            const windows = ['00:00–04:00', '04:00–08:00', '08:00–12:00', '12:00–16:00', '16:00–20:00', '20:00–24:00'];
            let maxIdx = 0, maxSum = 0;
            fourhourly.forEach((serie, i) => {
                const sum = (serie.data || []).reduce((acc, v) => acc + (v || 0), 0);
                if (sum > maxSum) { maxSum = sum; maxIdx = i; }
            });
            return maxSum > 0 ? windows[maxIdx] : '–';
        },
        peakTrafficWindowEntries() {
            const fourhourly = this.effectiveFourhourlyData;
            if (!fourhourly || fourhourly.length < 6) return '–';
            let maxSum = 0;
            fourhourly.forEach(serie => {
                const sum = (serie.data || []).reduce((acc, v) => acc + (v || 0), 0);
                if (sum > maxSum) maxSum = sum;
            });
            if (maxSum <= 0) return '–';
            const days = (fourhourly[0]?.data || []).length || 1;
            const avg = maxSum / days;
            return avg >= 10 ? Math.round(avg) : avg.toFixed(1);
        },
        avgDailyCleaningActivities() {
            const count = this.effectiveCleanerEvents.length;
            if (count === 0) return '0';
            const days = this.effectivePeriodDays;
            const avg = count / days;
            return avg >= 10 ? Math.round(avg) : avg.toFixed(1);
        },
        avgTrafficPerCleaning() {
            const cleaning = this.effectiveCleanerEvents.length;
            if (cleaning === 0) return '–';
            const totalTraffic = this.effectiveTotalTraffic;
            if (!totalTraffic) return '–';
            return Math.round(totalTraffic / cleaning);
        },
        avgActiveHoursPerDay() {
            if (!this.rawHourlyActivityData || this.rawHourlyActivityData.length === 0) return '–';
            const filtered = this.rawHourlyActivityData.filter(d => {
                if (this.includeWeekends) return true;
                const dow = new Date(d.date).getDay();
                return dow !== 0 && dow !== 6;
            });
            if (!filtered.length) return '–';
            const total = filtered.reduce((acc, d) => acc + (d.activeHours || 0), 0);
            const avg = total / filtered.length;
            return avg >= 10 ? Math.round(avg) : avg.toFixed(1);
        }
    },
    watch: {
        '$store.state.timezone'() {
            this.applyChartsTimezone();
        },
        includeWeekends() {
            if (this.visualizza_dati) this.buildStackedCharts();
        },
        client(value) {
            // Se stiamo caricando dalla route, non eseguire il watcher
            if (this.isLoadingFromRoute) {
                return;
            }
            
            if (value != undefined && value != null && value != "" && value != 0) {
                // Reset completo di building, floor, area e sensor
                this.buildings.length = 0;
                this.buildingValue = '';
                this.building = '';
                this.buildings = [];
                this.building_name = '';
                this.buildingActive = true; // Disabilita temporaneamente durante il caricamento
                
                this.floorActive = true;
                this.floors.length = 0;
                this.floor = '';
                this.floors = [];
                this.floor_name = '';
                
                this.areaActive = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                
                this.sensorActive = true;
                this.sensor_items.length = 0;
                this.sensorsValue = '';
                this.sensor_items = [];
                
                // Carica i buildings disponibili per il client selezionato
                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                .then(res => {
                    this.buildings = []; // Reset prima di popolare
                    
                    if (res.data && res.data.length > 0) {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.buildings.push(element);
                        });
                        this.buildingActive = false; // Abilita la select se ci sono buildings
                    } else {
                        // Nessun building disponibile, lascia disabilitato
                        console.warn('Nessun building disponibile per il client selezionato');
                        this.buildingActive = true;
                    }
                    
                    // Incrementa la chiave per forzare il re-render del v-select
                    this.b++;
                })
                .catch(error => {
                    console.error('Errore nel caricamento dei buildings:', error);
                    this.buildings = [];
                    this.buildingActive = true; // Mantieni disabilitato in caso di errore
                    this.b++;
                })
            } else {
                // Reset quando il client viene deselezionato
                this.buildingActive = true;
                this.buildings.length = 0;
                this.buildingValue = '';
                this.building = '';
                this.buildings = [];
                this.building_name = '';
                this.floorActive = true;
                this.floors.length = 0;
                this.floor = '';
                this.floors = [];
                this.floor_name = '';
                this.areaActive = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                this.sensorActive = true;
                this.sensor_items.length = 0;
                this.sensorsValue = '';
                this.sensor_items = [];
                this.b++;
                this.f++;
            }
        },
        building(value) {
            // Se stiamo caricando dalla route, non eseguire il watcher
            if (this.isLoadingFromRoute) {
                return;
            }
            
            if (value != undefined && value != null && value != "" && value != 0) {
                // Reset completo di floor, area e sensor
                this.floors.length = 0;
                this.floor = '';
                this.floors = [];
                this.floor_name = '';
                this.floorActive = true; // Disabilita temporaneamente durante il caricamento
                
                this.areaActive = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                
                this.sensorActive = true;
                this.sensor_items.length = 0;
                this.sensorsValue = '';
                this.sensor_items = [];
                
                const selectedOption = this.buildings.find(option => option.value === value);
                if (selectedOption) {
                    this.building_name = selectedOption.text;
                }
                
                // Carica i floors disponibili per il building selezionato
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                .then(res => {
                    this.floors = []; // Reset prima di popolare
                    
                    if (res.data && res.data.length > 0) {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.floors.push(element);
                        });
                        this.floorActive = false; // Abilita la select se ci sono floors
                    } else {
                        // Nessun floor disponibile, lascia disabilitato
                        console.warn('Nessun floor disponibile per il building selezionato');
                        this.floorActive = true;
                    }
                    
                    // Incrementa la chiave per forzare il re-render del v-select
                    this.f++;
                })
                .catch(error => {
                    console.error('Errore nel caricamento dei floors:', error);
                    this.floors = [];
                    this.floorActive = true; // Mantieni disabilitato in caso di errore
                    this.f++;
                })
            } else {
                // Reset quando il building viene deselezionato
                this.floorActive = true;
                this.floors.length = 0;
                this.floor = '';
                this.floors = [];
                this.floor_name = '';
                this.areaActive = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                this.sensorActive = true;
                this.sensor_items.length = 0;
                this.sensorsValue = '';
                this.sensor_items = [];
                this.building_name = '';
                this.f++;
            }
        },
        floor: {
            handler(value) {
                // Se stiamo caricando dalla route, non eseguire il watcher
                if (this.isLoadingFromRoute) {
                    return;
                }
                
                if (value && value !== "") {
                    // Reset di area e sensor
                    this.areas.length = 0;
                    this.area = '';
                    this.areas = [];
                    this.areaActive = true; // Disabilita temporaneamente durante il caricamento
                    
                    this.sensorActive = true;
                    this.sensor_items.length = 0;
                    this.sensorsValue = '';
                    this.sensor_items = [];
                    
                    const selectedOption = this.floors.find(option => option.value === value);
                    if (selectedOption) {
                        this.floor_name = selectedOption.text;
                    }
                    
                    // Carica le areas disponibili per il floor selezionato
                    axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                        floorId: value
                    })
                    .then(res => {
                        this.areas = []; // Reset prima di popolare
                        
                        if (res.data && res.data.length > 0) {
                            res.data.forEach(el => {
                                var element = { text: el.AreaName, value: el.id }
                                this.areas.push(element);
                            });
                            this.areaActive = false; // Abilita la select se ci sono areas
                        } else {
                            // Nessuna area disponibile, lascia disabilitato
                            console.warn('Nessuna area disponibile per il floor selezionato');
                            this.areaActive = true;
                        }
                        
                        // Incrementa la chiave per forzare il re-render del v-select
                        this.a++;
                    })
                    .catch(error => {
                        console.error('Errore nel caricamento delle areas:', error);
                        this.areas = [];
                        this.areaActive = true; // Mantieni disabilitato in caso di errore
                        this.a++;
                    });
                } else {
                    // Reset quando il floor viene deselezionato
                    this.floorActive = true;
                    this.floors.length = 0;
                    this.floor = '';
                    this.floors = [];
                    this.floor_name = '';
                    this.areaActive = true;
                    this.areas.length = 0;
                    this.area = '';
                    this.areas = [];
                    this.sensorActive = true;
                    this.sensor_items.length = 0;
                    this.sensorsValue = '';
                    this.sensor_items = [];
                    this.a++;
                }
            },
            immediate: true
        },
        area(value) {
            // Se stiamo caricando dalla route, non eseguire il watcher
            if (this.isLoadingFromRoute) {
                return;
            }
            
            if (value != undefined && value != null && value != "" && value != 0) {
                // Reset dei sensors
                this.sensor_items.length = 0;
                this.sensor_items = [];
                this.sensorsValue = "";
                this.sensorActive = true; // Disabilita temporaneamente durante il caricamento
                
                // Carica i sensors disponibili per l'area selezionata
                axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                    companyId: this.client,
                    buildingId: this.building,
                    floorId: this.floor,
                    areaId: value,
                    type: "Washroom"
                })
                .then(res => {
                    this.sensor_items = []; // Reset prima di popolare
                    
                    if (res.data && res.data.length > 0) {
                        res.data.forEach(el => {
                            var element = { text: el.DisplayName, value: el }
                            this.sensor_items.push(element);
                        });
                        this.sensorActive = false; // Abilita la select se ci sono sensors
                    } else {
                        // Nessun sensor disponibile, lascia disabilitato
                        console.warn('Nessun sensor disponibile per l\'area selezionata');
                        this.sensorActive = true;
                    }
                    
                    // Incrementa la chiave per forzare il re-render del v-select
                    this.s++;
                })
                .catch(error => {
                    console.error('Errore nel caricamento dei sensors:', error);
                    this.sensor_items = [];
                    this.sensorActive = true; // Mantieni disabilitato in caso di errore
                    this.s++;
                })
            } else {
                // Reset quando l'area viene deselezionata
                this.sensor_items.length = 0;
                this.sensor_items = [];
                this.sensorsValue = "";
                this.sensorActive = true;
                this.s++;
            }
        },
        sensorsValue(value) {
            if (value) {
                this.sensor_name = value.DisplayName;
                
                // Gestisci l'URL dell'immagine per i sensori Washroom
                let dispenserImage = value.DispenserImage;
                if (value.DispenserType === 'Washroom' || value.Type === 'Washroom') {
                    if (dispenserImage && !dispenserImage.startsWith('http')) {
                        dispenserImage = this.$store.state.URL_IMAGES_S3 + dispenserImage;
                    }
                }
                this.sensor_img = dispenserImage;
                
                this.sensor_unique = value.DispenserUnique;
                this.sensor_id = value.DispenserId || value.DispenserUnique || value.id;
                this.sensor_id_numeric = value.id || value.DispenserId; // ID numerico per le API
                this.sensor_type = value.DispenserSubtype || '';
                this.okActive = false;
                
                // Reset del calendario quando cambia il sensore
                this.date = [];
                
                console.log('Watcher sensorsValue - Sensore impostato:', {
                    sensor_id: this.sensor_id,
                    sensor_id_numeric: this.sensor_id_numeric,
                    sensor_unique: this.sensor_unique,
                    sensor_img: this.sensor_img,
                    isLoadingFromRoute: this.isLoadingFromRoute
                });
                
                // Carica i dati con il filtro di 1 giorno (che imposta anche i colori corretti)
                // Solo se non stiamo caricando dalla route E non siamo nel dialog di scelta sensore
                // (altrimenti LoadData() al click OK farà il caricamento, evitando doppia richiesta e dati che scompaiono)
                if (!this.isLoadingFromRoute && !this.scelta) {
                    this.ChangeDate('1');
                }
            }
        },
        '$i18n.locale'() {
            // Quando cambia la lingua, aggiorna le etichette del grafico daytime
            if (this.series_daytime && this.series_daytime.length > 0) {
                // Aggiorna i nomi delle serie con le nuove traduzioni
                this.series_daytime = [
                    { name: this.$t('washroomFrequency.morning'), data: this.series_daytime[0].data },
                    { name: this.$t('washroomFrequency.afternoon'), data: this.series_daytime[1].data }
                ];
                
                // Aggiorna anche il tooltip con la traduzione corretta di "events"
                const eventsLabel = this.$t('washroomFrequency.events');
                this.chartOptions_daytime.tooltip = {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (val, { dataPointIndex, w }) {
                            const series = w.config.series;
                            let total = 0;
                            series.forEach(s => {
                                total += s.data[dataPointIndex] || 0;
                            });
                            const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                            return val + " " + eventsLabel + " (" + percentage + "%)";
                        }
                    }
                };
                
                // Mantieni la larghezza delle colonne coerente con il numero di giorni
                const numDays = this.chartOptions_daytime.xaxis.categories.length;
                let columnWidth = '70%';
                
                if (numDays <= 1) {
                    columnWidth = '8%';
                } else if (numDays <= 3) {
                    columnWidth = '20%';
                } else if (numDays <= 7) {
                    columnWidth = '40%';
                } else if (numDays <= 14) {
                    columnWidth = '60%';
                }
                
                this.chartOptions_daytime.plotOptions.bar.columnWidth = columnWidth;
                
                // Forza il re-render del grafico
                this.keyDaytime++;
                this.updateAllChartSubtitles();
            }
            
            // Quando cambia la lingua, aggiorna le etichette del grafico a 4 ore
            if (this.series_fourhourly && this.series_fourhourly.length > 0) {
                // Determina il prefisso in base alla lingua corrente
                const locale = this.$i18n.locale;
                let prefix = 'f'; // default italiano
                if (locale === 'en') {
                    prefix = 'b';
                } else if (locale === 'de') {
                    prefix = 'z';
                }
                
                // Aggiorna i nomi delle serie con le nuove traduzioni
                this.series_fourhourly = [
                    { name: this.$t(`washroomFrequency.${prefix}1`), data: this.series_fourhourly[0].data },
                    { name: this.$t(`washroomFrequency.${prefix}2`), data: this.series_fourhourly[1].data },
                    { name: this.$t(`washroomFrequency.${prefix}3`), data: this.series_fourhourly[2].data },
                    { name: this.$t(`washroomFrequency.${prefix}4`), data: this.series_fourhourly[3].data },
                    { name: this.$t(`washroomFrequency.${prefix}5`), data: this.series_fourhourly[4].data },
                    { name: this.$t(`washroomFrequency.${prefix}6`), data: this.series_fourhourly[5].data }
                ];
                
                // Aggiorna anche il tooltip con la traduzione corretta di "events"
                const eventsLabel = this.$t('washroomFrequency.events');
                this.chartOptions_fourhourly.tooltip = {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (val, { dataPointIndex, w }) {
                            const series = w.config.series;
                            let total = 0;
                            series.forEach(s => {
                                total += s.data[dataPointIndex] || 0;
                            });
                            const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                            return val + " " + eventsLabel + " (" + percentage + "%)";
                        }
                    }
                };
                
                // Mantieni la larghezza delle colonne coerente con il numero di giorni
                const numDays = this.chartOptions_fourhourly.xaxis.categories.length;
                let columnWidth = '70%';
                
                if (numDays <= 1) {
                    columnWidth = '8%';
                } else if (numDays <= 3) {
                    columnWidth = '20%';
                } else if (numDays <= 7) {
                    columnWidth = '40%';
                } else if (numDays <= 14) {
                    columnWidth = '60%';
                }
                
                this.chartOptions_fourhourly.plotOptions.bar.columnWidth = columnWidth;
                
                // Forza il re-render del grafico
                this.keyFourHourly++;
                this.updateAllChartSubtitles();
            }
            
            // Quando cambia la lingua, aggiorna le etichette del grafico alert
            if (this.series_alert && this.series_alert.length > 0) {
                // Aggiorna i nomi delle serie con le nuove traduzioni
                this.series_alert = [
                    { name: this.$t('washroomFrequency.normalTraffic'), data: this.series_alert[0].data },
                    { name: this.$t('washroomFrequency.trafficDuringAlert'), data: this.series_alert[1].data }
                ];
                
                // Forza il re-render del grafico
                this.keyAlert++;
                this.updateAllChartSubtitles();
            }
            
            // Quando cambia la lingua, aggiorna le etichette del grafico timeline
            if (this.showTimelineGraph && this.lastTimelineData !== null && this.lastTimelineStart !== null && this.lastTimelineEnd !== null) {
                // Rigenera il grafico timeline con le nuove traduzioni
                this.ProcessTimelineData(this.lastTimelineData, this.lastTimelineStart, this.lastTimelineEnd);
            }
        }
    },
    created() {
        if (this.$store.state.company) {
            this.overlay = true;
            this.DownloadCompanyDatas();
        }
    },
    mounted() {
        this.applyChartsTimezone();
        // this.overlay = true;


        // this.GetDataStacked(7);
        // // this.buildingValue = this.building_items[0];
        // // this.b ++;
        // this.date.push(new Date().toISOString().toString().substr(0,10));
        // this.GetData(new Date().toISOString().toString().substr(0,10),new Date(),0)
        // this.date.push(new Date().toISOString().toString().substr(0,10));
        // this.GetSensorData(this.subtractDays(-4, new Date()).toISOString().toString().substr(0,10), this.subtractDays(1, new Date()).toISOString().toString().substr(0,10));
    },
    methods: {
        clampPct(val, min, max) { return Math.min(Math.max(val, min), max); },

        updateAllChartSubtitles() {
            // Aggiorna i sottotitoli di tutti i grafici con il periodo corrente
            if (!this.currentStartDate || !this.currentEndDate) {
                return;
            }
            
            const locale = this.$i18n.locale || 'en';
            
            // Aggiorna tutti i chartOptions con i sottotitoli del periodo usando $set per garantire la reattività
            this.$set(this, 'chartOptions_bin', addPeriodSubtitleToChartOptions(
                this.chartOptions_bin, 
                this.currentStartDate, 
                this.currentEndDate, 
                locale
            ));
            
            this.$set(this, 'chartOptions_alert', addPeriodSubtitleToChartOptions(
                this.chartOptions_alert, 
                this.currentStartDate, 
                this.currentEndDate, 
                locale
            ));
            
            this.$set(this, 'chartOptions_timeline', addPeriodSubtitleToChartOptions(
                this.chartOptions_timeline, 
                this.currentStartDate, 
                this.currentEndDate, 
                locale
            ));
            
            this.$set(this, 'chartOptions_daytime', addPeriodSubtitleToChartOptions(
                this.chartOptions_daytime, 
                this.currentStartDate, 
                this.currentEndDate, 
                locale
            ));
            
            this.$set(this, 'chartOptions_fourhourly', addPeriodSubtitleToChartOptions(
                this.chartOptions_fourhourly, 
                this.currentStartDate, 
                this.currentEndDate, 
                locale
            ));
            
            // PunctualchartOptions non ha bisogno del sottotitolo (è un indicatore real-time)
            this.applyChartsTimezone();
        },

        /** Applica la timezone dello store a tutte le label/tooltip dei grafici (asse x e tooltip). */
        applyChartsTimezone() {
            const tz = this.$store.state.timezone || 'Europe/Rome';
            applyTimezoneToApexCharts(
                {
                    chartOptions_bin: this.chartOptions_bin,
                    chartOptions_alert: this.chartOptions_alert,
                    chartOptions_timeline: this.chartOptions_timeline,
                    chartOptions_daytime: this.chartOptions_daytime,
                    chartOptions_fourhourly: this.chartOptions_fourhourly,
                    chartOptions_stacked: this.chartOptions_stacked,
                    chartOptions_bar: this.chartOptions_bar,
                },
                tz,
                { datetimeAxisKeys: ['chartOptions_timeline'] }
            );
        },
        
        applyDoorCounterAdjustment(value) {
            // Per sensori Door Count: tutti i dati con decimali approssimati per difetto
            return applyDoorCountFloor(value, this.sensor_type, { divideBy2: true });
        },
        /**
         * Distribuisce `adjustedTotal` (già corretto con floor) proporzionalmente ai bucket raw,
         * usando il metodo del resto più grande per garantire che la somma dei bucket
         * eguagli esattamente `adjustedTotal`. Questo assicura coerenza tra grafici che
         * aggregano gli stessi dati con granularità di bucket diverse.
         * @param {number} adjustedTotal - Totale già aggiustato (es. floor(rawTotal/2))
         * @param {number[]} rawBuckets  - Valori grezzi di ciascun bucket
         * @returns {number[]} Valori aggiustati per ciascun bucket
         */
        distributeProportionally(adjustedTotal, rawBuckets) {
            const rawTotal = rawBuckets.reduce((a, b) => a + b, 0);
            if (rawTotal === 0 || adjustedTotal === 0) {
                return rawBuckets.map(() => 0);
            }
            const floored = rawBuckets.map(b => Math.floor(adjustedTotal * b / rawTotal));
            const sumFloored = floored.reduce((a, b) => a + b, 0);
            const remainder = adjustedTotal - sumFloored;
            const fractions = rawBuckets
                .map((b, i) => ({ i, frac: (adjustedTotal * b / rawTotal) - floored[i] }))
                .sort((a, b) => b.frac - a.frac);
            const result = [...floored];
            for (let k = 0; k < remainder; k++) {
                result[fractions[k].i]++;
            }
            return result;
        },
        /** Estrae il valore di traffico da un record evento (supporta doorCount.value, doorCount numerico, typeSpecificProps.doorCount, People Counter, ecc.) */
        getTrafficValue(el) {
            if (!el) return 0;
            let v = null;
            if (el.doorCount != null)
                v = typeof el.doorCount === 'object' ? el.doorCount.value : el.doorCount;
            if (v == null && el.typeSpecificProps && el.typeSpecificProps.doorCount != null)
                v = typeof el.typeSpecificProps.doorCount === 'object' ? el.typeSpecificProps.doorCount.value : el.typeSpecificProps.doorCount;
            if (v == null) return 0;
            const n = Number(v);
            if (isNaN(n) || n < 0) return 0;
            if (n > 100) return 100;
            return n;
        },
        /** Mostra grafici con assi e valori a zero (usato quando non ci sono dati o in caso di errore elaborazione) */
        applyEmptyChartsState(start, nextDay, time) {
            this.rawDailyTrafficData = [];
            this.rawHourlyActivityData = [];
            try {
                if (!start || !nextDay) {
                    this.series_dispenser = [{ data: [0], name: this.sensor_name || '' }];
                    this.chartOptions_bin.xaxis.categories = [start ? String(start).substr(0, 10) : ''];
                    this.keyStacked++;
                    if (time == 1) this.ProcessTimelineData([], start || '', nextDay || '');
                    this.overlay = false;
                    this.visualizza_dati = true;
                    return;
                }
            const getAllDatesInRange = (startStr, endStr) => {
                const dates = [];
                const startDateObj = new Date(startStr.substr(0, 10));
                const endDateObj = new Date(endStr.substr(0, 10));
                if (isNaN(startDateObj.getTime()) || isNaN(endDateObj.getTime())) return dates;
                let currentDate = new Date(startDateObj);
                while (currentDate <= endDateObj) {
                    dates.push(toBackendDate(currentDate));
                    currentDate.setDate(currentDate.getDate() + 1);
                }
                return dates;
            };
            const allDates = getAllDatesInRange(start, nextDay);
            const categoriesBin = allDates.length ? allDates : [start.substr(0, 10)];
            const data_ = categoriesBin.map(() => 0);
            this.chartOptions_bin = {
                ...this.chartOptions_bin,
                xaxis: { ...this.chartOptions_bin.xaxis, categories: categoriesBin },
                yaxis: { ...this.chartOptions_bin.yaxis, min: 0, max: 2, tickAmount: 2 },
            };
            this.series_dispenser = [{ data: data_, name: this.sensor_name || '' }];
            const n = categoriesBin.length;
            let columnWidth = '70%';
            if (n <= 1) columnWidth = '5%';
            else if (n <= 3) columnWidth = '15%';
            else if (n <= 7) columnWidth = '30%';
            else if (n <= 14) columnWidth = '55%';
            this.chartOptions_bin.plotOptions.bar.columnWidth = columnWidth;
            this.keyStacked++;
            this.updateAllChartSubtitles();
            this.ProcessDaytimeData([], start, nextDay);
            this.ProcessFourHourlyData([], start, nextDay);
            this.ProcessAlertData([], start, nextDay, time);
            if (time == 1) this.ProcessTimelineData([], start, nextDay);
            this.averageDailyTraffic = 0;
            this.computeAverageDailyAlertsPeriod(start, nextDay);
            this.overlay = false;
            this.visualizza_dati = true;
            } catch (err) {
                console.warn('applyEmptyChartsState error:', err);
                this.series_timeline = [{ name: this.$t('washroomFrequency.events'), data: [] }];
                this.keyTimeline++;
                this.overlay = false;
                this.visualizza_dati = true;
            }
        },
        normalizeReceivedAt(v) {
            if (v == null) return '';
            if (typeof v === 'number') {
                const d = new Date(v);
                if (isNaN(d.getTime())) return '';
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const h = String(d.getHours()).padStart(2, '0');
                const min = String(d.getMinutes()).padStart(2, '0');
                const s = String(d.getSeconds()).padStart(2, '0');
                return `${y}-${m}-${day} ${h}:${min}:${s}`;
            }
            const s = String(v).trim();
            if (!s || s.indexOf('0000-00-00') === 0) return '';
            if (s.indexOf('T') !== -1) {
                // "2026.03.04T09:50:56" -> "2026-03-04 09:50:56" (trattini per parsing e .substr sicuro)
                const withSpace = s.replace('T', ' ');
                const datePart = withSpace.substr(0, 10).replace(/\./g, '-');
                const timePart = withSpace.substr(11, 8);
                return timePart ? datePart + ' ' + timePart : datePart;
            }
            if (s.length >= 10)
                return s.substr(0, 19).replace(/\./g, '-');
            return s;
        },
        /** Restituisce Date o null per stringhe invalide / 0000-00-00 (evita errori in grafici). */
        parseDateSafe(str) {
            if (str == null || typeof str !== 'string') return null;
            const s = String(str).trim();
            if (!s || s.indexOf('0000-00-00') === 0) return null;
            const normalized = s.replace(/\./g, '-').replace('T', ' ');
            const iso = normalized.length > 10 && normalized.charAt(10) === ' ' ? normalized.replace(' ', 'T') : normalized;
            const d = new Date(iso);
            return isNaN(d.getTime()) ? null : d;
        },
        /** Valori per il grafico punctual (arrotondati per difetto, senza dimezzare) */
        getPunctualChartValues(rawAlertValue, rawPartialCount) {
            const adjAlert = applyDoorCountFloor(Number(rawAlertValue) || 0, this.sensor_type, { divideBy2: false });
            const adjPartial = applyDoorCountFloor(Number(rawPartialCount) || 0, this.sensor_type, { divideBy2: false });
            const punctualValue = Math.max(0, adjAlert - adjPartial);
            return { punctualValue, displayPartialCount: adjPartial };
        },
        
        getCleaningStateLabel() {
            switch (this.cleaning_state) {
                case 'Cleaning Required':
                    return this.$t('washroomFrequency.cleaningRequired');
                case 'Might need clean':
                    return this.$t('washroomFrequency.mightNeedClean');
                case "Doesn't need clean":
                    return this.$t('washroomFrequency.doesntNeedClean');
                default:
                    return this.cleaning_state;
            }
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                this.$router.push('/');
            }
        },
        SetMinDate() {
            this.maxDate = new Date(this.date.start.getTime() + 15 * 24 * 60 * 60 * 1000);
        },
        /**
         * Chiamato dal pulsante OK del calendario tramite handleCalendarOk().
         * Riceve le date già validate e catturate prima del save() del menu.
         */
        GetDataByDate(startStr, endStr) {
            if (!startStr) return;

            this.overlay = true;

            const startDate = toBackendDate(new Date(startStr)) + " 00:00:00";
            const endDate   = toBackendDate(new Date(endStr))   + " 23:59:59";

            this.currentStartDate = startDate;
            this.currentEndDate   = endDate;

            const isSingleDay = startStr === endStr;
            const timeParam   = isSingleDay ? 1 : 0;
            this.currentPeriod = isSingleDay ? '1' : 'custom';
            this.showTimelineGraph = isSingleDay;

            // Numero di giorni nel periodo (usato da GetDataStacked)
            const diffDays = Math.max(1, Math.round(
                (new Date(endStr).getTime() - new Date(startStr).getTime()) / (1000 * 60 * 60 * 24)
            ) + 1);

            // Deseleziona colori quick filter (nessun filtro rapido attivo)
            this.colore4h = "#DAE0EC";
            this.colore1d = "#DAE0EC";
            this.colore3d = "#DAE0EC";
            this.colore1w = "#DAE0EC";
            this.colore2w = "#DAE0EC";

            this.GetSensorData(startDate, endDate, timeParam);
            this.GetDataStacked(diffDays);
        },

        /**
         * Handler per il pulsante OK del calendario.
         * Cattura le date PRIMA di save() (che chiude il menu) e usa $nextTick
         * per garantire che Vue abbia propagato tutti gli aggiornamenti reattivi
         * del date-picker prima di avviare il caricamento dati.
         */
        handleCalendarOk() {
            const startStr = this.date[0];
            const endStr   = this.date[1] || this.date[0];
            this.$refs.menu.save(this.date);
            this.$nextTick(() => {
                this.GetDataByDate(startStr, endStr);
            });
        },
        DownloadSchedule() {
            axios.post(this.$store.state.URL_GETSCHEDULEDATA, {
                "sensor": this.sensor_id
            })
                .then(res => {
                    var csv = "SENSOR NAME;BUILDING;FLOOR;CLEANING DATE;CLEANING HOUR;CLEANER\n";
                    res.data.map(el => {
                        csv += el.DeviceName + ";"
                        csv += this.building_name + ";"
                        csv += this.floor_name + ";"
                        csv += el.Timestamp_Gestione.split(" ")[0] != "0000-00-00" ? el.Timestamp_Gestione.split(" ")[0] + ";" : "--" + ";"
                        csv += el.Timestamp_Gestione.split(" ")[1] != "00:00:00" ? el.Timestamp_Gestione.split(" ")[1] + ";" : "--" + ";"
                        csv += el.User + "\n"

                    })

                    let csvContent = "data:text/csv;charset=utf-8," + csv;
                    var encodedUri = encodeURI(csvContent);
                    const link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", "cleaning_schedule.csv");
                    link.click();

                }
                )
        },
        async DownloadCompanyDatas() {
            try {
                // Se ci sono parametri nella route, nascondi il dialog di scelta immediatamente
                if (this.$route.params && this.$route.params.sensorId) {
                    this.scelta = false;
                    // Imposta la flag per evitare che i watcher interferiscano
                    this.isLoadingFromRoute = true;
                }
                
                // Carica i clienti
                const clientsResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT);
                this.clients = clientsResponse.data.map(el => ({ text: el.CompanyName, value: el.id }));
                
                // Se ci sono parametri nella route, carica i dati del sensore
                if (this.isLoadingFromRoute) {
                    const { company, building, floor, area, sensorId } = this.$route.params;
                    console.log('Parametri route ricevuti:', { company, building, floor, area, sensorId });
                    
                    // Abilita i campi e imposta il cliente
                    this.buildingActive = false;
                    this.floorActive = false;
                    this.areaActive = false;
                    this.sensorActive = false;
                    this.client = company;
                    
                    // Carica gli edifici
                    const buildingsResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                        companyId: company
                    });
                    this.buildings = buildingsResponse.data.map(el => ({ text: el.BuildingName, value: el.id }));
                    
                    // Imposta l'edificio e carica i piani
                    this.building = building;
                    const floorsResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                        buildingId: building
                    });
                    this.floors = floorsResponse.data.map(el => ({ text: el.FloorName, value: el.id }));
                    
                    // Imposta il piano e carica le aree
                    this.floor = floor;
                    const areasResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                        floorId: floor
                    });
                    this.areas = areasResponse.data.map(el => ({ text: el.AreaName, value: el.id }));
                    
                    // Imposta l'area e carica i sensori
                    this.area = area;
                    const sensorsResponse = await axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                        companyId: company,
                        buildingId: building,
                        floorId: floor,
                        areaId: area,
                        type: "Washroom"
                    });
                    
                    this.sensor_items = sensorsResponse.data.map(el => ({ text: el.DisplayName, value: el }));
                    
                    console.log('Sensori disponibili:', sensorsResponse.data.map(s => ({ id: s.id, name: s.DisplayName })));
                    console.log('Cerco sensore con id:', sensorId, 'tipo:', typeof sensorId);
                    
                    // Trova e imposta il sensore corretto usando l'id
                    const sensor = sensorsResponse.data.find(s => s.id === parseInt(sensorId));
                    console.log('Sensore trovato:', sensor);
                    
                    if (sensor) {
                        // Imposta sensorsValue con l'oggetto sensore diretto (non wrapped)
                                        this.sensorsValue = sensor;
                                        this.sensor_name = sensor.DisplayName;
                                        
                                        // Gestisci l'URL dell'immagine per i sensori Washroom
                                        let dispenserImage = sensor.DispenserImage;
                                        if (sensor.DispenserType === 'Washroom' || sensor.Type === 'Washroom') {
                                            if (dispenserImage && !dispenserImage.startsWith('http')) {
                                                dispenserImage = this.$store.state.URL_IMAGES_S3 + dispenserImage;
                                            }
                                        }
                                        this.sensor_img = dispenserImage;
                                        
                                        this.sensor_unique = sensor.DispenserUnique;
                                        this.sensor_id = sensor.DispenserId || sensor.DispenserUnique || sensor.id;
                                        this.sensor_id_numeric = sensor.id || sensor.DispenserId; // ID numerico per le API
                                        this.sensor_type = sensor.DispenserSubtype || '';
                                        
                                        console.log('Sensore impostato:', {
                                            sensor_id: this.sensor_id,
                                            sensor_id_numeric: this.sensor_id_numeric,
                                            sensor_unique: this.sensor_unique,
                                            sensor_name: this.sensor_name,
                                            sensor_img: this.sensor_img
                                        });
                                        
                                        // Resetta la flag prima di caricare i dati (così i watcher funzionano normalmente)
                                        this.isLoadingFromRoute = false;
                                        // Carica i dati con il filtro di 1 giorno
                                        this.ChangeDate('1');
                    } else {
                        console.error('Sensore non trovato con id:', sensorId);
                        this.isLoadingFromRoute = false;
                        this.overlay = false;
                    }
                } else {
                    // Nessun parametro nella route, resetta la flag
                    this.isLoadingFromRoute = false;
                }
            } catch (error) {
                console.error('Errore nel caricamento dei dati:', error);
                this.isLoadingFromRoute = false;
                this.overlay = false;
            }
        },
        LoadData() {
            this.scelta = false;
            // Simula il click sul quick filter "1 day": riusa lo stesso flusso così i grafici si popolano correttamente
            this.ChangeDate('1');
        },
        /** Helper: carica i dati dell'ultimo intervento (URL_LASTMANAGED) e aggiorna lo stato.
         *  Può girare in parallelo con GetSensorData e GetDataStacked. */
        async _loadLastManaged(period) {
            try {
                const res = await axios.post(this.$store.state.URL_LASTMANAGED, { "sensor": this.sensor_id });
                if (!res.data || res.data.length === 0 || !res.data[0]) {
                    this.last_managed = null;
                    this.alert_threshold = null;
                    this.colore_stato = 'grey';
                    this.cleaning_state = '-';
                    this.series_punctual = [
                        { name: this.$t('washroomFrequency.eventToAlert'), data: [0] },
                        { name: this.$t('washroomFrequency.eventTriggered'), data: [0] }
                    ];
                    if (period === '1') {
                        this.currentTraffic = 0;
                        this.averageAlerts = null;
                        this.averageDailyAlertsPeriod = null;
                    }
                } else {
                    this.last_managed = res.data[0]?.Timestamp_Gestione || null;
                    const rawAlertValue = Number(res.data[0]?.AlertValue || 0);
                    const rawPartialCount = Number(res.data[0]?.PartialCount || 0);
                    this.alert_threshold = rawAlertValue;
                    const perc = (rawPartialCount * 100) / (rawAlertValue || 1);
                    if (perc >= 100) {
                        this.colore_stato = 'red';
                        this.cleaning_state = 'Cleaning Required';
                    } else if (perc > 25) {
                        this.colore_stato = '#ffac27';
                        this.cleaning_state = 'Might need clean';
                    } else {
                        this.colore_stato = 'green';
                        this.cleaning_state = "Doesn't need clean";
                    }
                    const punctualChart = this.getPunctualChartValues(rawAlertValue, rawPartialCount);
                    this.series_punctual = [
                        { name: this.$t('washroomFrequency.eventToAlert'), data: [punctualChart.punctualValue] },
                        { name: this.$t('washroomFrequency.eventTriggered'), data: [punctualChart.displayPartialCount] }
                    ];
                    if (period === '1') {
                        this.currentTraffic = rawPartialCount;
                        this.averageAlerts = res.data[0]?.AverageAlerts || null;
                        this.currentTime = formatDateTimeDisplay(new Date(), this.$store.state.timezone || 'Europe/Rome');
                    }
                }
                this.radialKey += 1;
            } catch (err) {
                console.error('Errore _loadLastManaged:', err);
            }
        },

        ChangeDate(period) {
            this.currentPeriod = period;
            this.overlay = true;
            this.date = [];

            // Reset colori quick filter (feedback UI immediato, prima delle chiamate API)
            this.colore4h = '#DAE0EC';
            this.colore1d = '#DAE0EC';
            this.colore3d = '#DAE0EC';
            this.colore1w = '#DAE0EC';
            this.colore2w = '#DAE0EC';

            let startDate, endDate, nDays, time, showTimeline;

            switch (period) {
                case "4h":
                    startDate = toBackendDateTime(this.subtractHours(4, new Date()));
                    endDate = toBackendDateTime(new Date());
                    nDays = 1; time = 1; showTimeline = true;
                    this.colore4h = '#213A8F';
                    break;
                case "1":
                    startDate = toBackendDate(new Date()) + " 00:00:00";
                    endDate = toBackendDate(new Date()) + " 23:59:59";
                    nDays = 1; time = 1; showTimeline = true;
                    this.colore1d = '#213A8F';
                    break;
                case "3":
                    startDate = toBackendDate(this.subtractDays(-2, new Date())) + " 00:00:00";
                    endDate = toBackendDate(this.subtractDays(1, new Date())) + " 23:59:59";
                    nDays = 3; time = 0; showTimeline = false;
                    this.colore3d = '#213A8F';
                    break;
                case "7":
                    startDate = toBackendDate(this.subtractDays(-6, new Date())) + " 00:00:00";
                    endDate = toBackendDate(this.subtractDays(1, new Date())) + " 23:59:59";
                    nDays = 7; time = 0; showTimeline = false;
                    this.colore1w = '#213A8F';
                    break;
                case "14":
                    startDate = toBackendDate(this.subtractDays(-13, new Date())) + " 00:00:00";
                    endDate = toBackendDate(this.subtractDays(1, new Date())) + " 23:59:59";
                    nDays = 14; time = 0; showTimeline = false;
                    this.colore2w = '#213A8F';
                    break;
                case "30":
                    startDate = toBackendDate(this.subtractDays(-29, new Date())) + " 00:00:00";
                    endDate = toBackendDate(this.subtractDays(1, new Date())) + " 23:59:59";
                    nDays = 30; time = 0; showTimeline = false;
                    this.colore3d = '#213A8F';
                    break;
                default:
                    this.overlay = false;
                    return;
            }

            this.currentStartDate = startDate;
            this.currentEndDate = endDate;
            this.showTimelineGraph = showTimeline;

            // Tutte e 3 le chiamate API partono in parallelo
            Promise.all([
                this._loadLastManaged(period),
                this.GetSensorData(startDate, endDate, time),
                this.GetDataStacked(nDays)
            ]).catch(err => {
                console.error('Errore ChangeDate:', err);
                this.overlay = false;
            });
        },
        subtractHours(numOfHours, date = new Date()) {
            date.setHours(date.getHours() - numOfHours + 1);
            return date;
        },
        subtractDays(numOfDays, date = new Date()) {
            date.setDate(date.getDate() + numOfDays);

            return date;
        },
        async loadSensorAlerts() {
            // Carica tutti gli alert per il sensore corrente
            try {
                // Usa sensor_id_numeric se disponibile, altrimenti sensor_id
                const sensorIdToUse = this.sensor_id_numeric || this.sensor_id;
                
                const response = await axios.post(this.$store.state.URL_ALERTS, {
                    "companyId": this.$store.state.company,
                    "sensorId": sensorIdToUse
                });
                
                // Come in AlertsView.vue, la risposta dovrebbe essere direttamente un array
                // Ma se è un oggetto vuoto o non è un array, convertiamolo in array vuoto
                let alertsArray = [];
                if (Array.isArray(response.data)) {
                    alertsArray = response.data;
                } else if (response.data && response.data.code === 500) {
                    console.warn('⚠️ Errore 500 dall\'API alert:', response.data.data);
                    alertsArray = [];
                } else {
                    console.warn('⚠️ La risposta non è un array, probabilmente nessun alert presente');
                    alertsArray = [];
                }
                
                this.sensorAlerts = alertsArray;
                console.log('✅ Alert caricati:', this.sensorAlerts.length);
                return this.sensorAlerts;
            } catch (error) {
                console.error('❌ Errore nel caricamento degli alert:', error);
                this.sensorAlerts = [];
                return [];
            }
        },
        /**
         * Carica gli eventi CLEANER_SCAN per l'area del sensore.
         * Filtra per building/floor/area invece che per deviceId perché sensor_unique
         * è un clearedDeviceId (bottone fisico), non il deviceId del gateway RFID.
         * Il backend (path admin) usa executeViaDevices: trova tutti i device dell'area
         * e restituisce i loro eventi. limit=0 → nessun limite di paginazione.
         */
        async loadCleanerScanEvents(startDate, endDate) {
            try {
                const baseUrl = this.$store.state.BASE_URL || this.$store.state.BASE_PATH;
                const url = `${baseUrl}/v1/events`;

                // Ricava i nomi direttamente dagli array caricati (building_name/floor_name
                // potrebbero non essere impostati se i watcher erano bloccati da isLoadingFromRoute)
                const buildingText = (this.buildings.find(b => b.value === this.building) || {}).text || this.building_name || '';
                const floorText = (this.floors.find(f => f.value === this.floor) || {}).text || this.floor_name || '';
                const areaText = (this.areas.find(a => a.value === this.area) || {}).text || '';

                const params = {
                    eventType: 'CLEANER_SCAN',
                    limit: 0
                };
                if (buildingText) params.building = buildingText;
                if (floorText) params.floor = floorText;
                if (areaText) params.area = areaText;

                console.log('[CleanerScan] chiamata con params:', params, '| sensor_unique:', this.sensor_unique);

                const token = localStorage.getItem('jwtToken');
                const response = await axios.get(url, {
                    params,
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                let items = (response.data && response.data.items && Array.isArray(response.data.items)) ? response.data.items : [];
                console.log('[CleanerScan] eventi ricevuti per area:', items.length);

                // Filtra client-side gli eventi che riguardano questo specifico sensore
                // (sensor_unique è il clearedDeviceId del bottone associato)
                const forThisSensor = items.filter(event => {
                    if (event.deviceId === this.sensor_unique) return true;
                    return event.typeSpecificProps &&
                        Array.isArray(event.typeSpecificProps.clearedDeviceIds) &&
                        event.typeSpecificProps.clearedDeviceIds.includes(this.sensor_unique);
                });
                console.log('[CleanerScan] eventi per questo sensore (clearedDeviceIds):', forThisSensor.length);

                // Trova l'evento più recente (senza filtro data) → usato nel box "Last Cleaning"
                let latestTs = null;
                forThisSensor.forEach(event => {
                    const t = event.typeSpecificProps?.timestamp || event.timestamp || event.createdAt;
                    if (!t) return;
                    if (!latestTs || new Date(t) > new Date(latestTs)) latestTs = t;
                });
                this.lastCleanerScanDate = latestTs;
                console.log('[CleanerScan] lastCleanerScanDate:', latestTs);

                // Filtro data con confronto stringa nel timezone dell'app
                // (evita new Date("YYYY-MM-DD HH:MM:SS") che usa l'ora locale del browser)
                // cleanerScanEvents è usato per i KPI (conteggio pulizie nel periodo)
                const tz = this.$store.state.timezone || 'Europe/Rome';
                const startDateStr = startDate ? startDate.toString().substr(0, 10) : null;
                const endDateStr = endDate ? endDate.toString().substr(0, 10) : null;

                this.cleanerScanEvents = forThisSensor.filter(event => {
                    if (!startDateStr || !endDateStr) return true;
                    const t = event.typeSpecificProps?.timestamp || event.timestamp || event.createdAt;
                    if (!t) return false;
                    try {
                        const eventDateStr = new Date(t).toLocaleDateString('en-CA', { timeZone: tz });
                        return eventDateStr >= startDateStr && eventDateStr <= endDateStr;
                    } catch { return false; }
                });
            } catch (e) {
                console.warn('Cleaning log events (CLEANER_SCAN) non caricati:', e);
                this.cleanerScanEvents = [];
            }
        },
        isDuringAlert(timestamp) {
            // Verifica se un timestamp è durante un periodo di alert
            if (!this.sensorAlerts || this.sensorAlerts.length === 0) {
                return false;
            }
            
            // Converti il timestamp dal formato "2026.01.10T01:00:13" a formato standard
            const normalizedTimestamp = timestamp.replace(/\./g, '-').replace('T', ' ');
            const eventDate = new Date(normalizedTimestamp);
            
            for (const alert of this.sensorAlerts) {
                // Se l'alert è stato gestito (Gestito == 1), NON considerarlo più attivo
                // indipendentemente dal valore di Timestamp_Gestione
                if (alert.Gestito == 1) {
                    // Alert risolto: verifica solo se l'evento è tra inizio alert e gestione
                    const alertStart = new Date(alert.Timestamp);
                    
                    // Se il timestamp di gestione è valido, usa quello come fine
                    // altrimenti considera l'alert come risolto immediatamente (fine = inizio)
                    let alertEnd = alertStart;
                    if (alert.Timestamp_Gestione && alert.Timestamp_Gestione !== '0000-00-00 00:00:00') {
                        alertEnd = new Date(alert.Timestamp_Gestione);
                    }
                    
                    // Verifica se l'evento è nell'intervallo [alertStart, alertEnd]
                    if (eventDate >= alertStart && eventDate <= alertEnd) {
                        return true;
                    }
                } else {
                    // Alert NON gestito: è ancora attivo, considera tutto da inizio alert fino ad ora
                    const alertStart = new Date(alert.Timestamp);
                    const alertEnd = new Date(); // Fino ad ora
                    
                    if (eventDate >= alertStart && eventDate <= alertEnd) {
                        return true;
                    }
                }
            }
            
            return false;
        },
        async GetSensorData(start, nextDay, time = 0) {
            // Ogni chiamata riceve un ID univoco: le risposte con ID diverso dall'ultimo
            // vengono scartate, evitando che richieste vecchie sovrascrivano dati più recenti.
            const requestId = ++this.sensorDataRequestId;

            start = start.length == 10 ? start + " 00:00:00" : start.replace("T", " ");
            nextDay = nextDay.length == 10 ? nextDay + " 00:00:00" : nextDay.replace("T", " ");

            // Tutte le chiamate di supporto partono in parallelo con la chiamata dati principale
            const alertsPromise = this.loadSensorAlerts();
            const cleanerPromise = this.loadCleanerScanEvents(start, nextDay);
            const dataPromise = axios.post(this.$store.state.URL_GET_DATA_FROM_DYNAMO, {
                "sensor_id": this.sensor_unique,
                "from": start,
                "to": nextDay
            });

            let res;
            try {
                [,, res] = await Promise.all([alertsPromise, cleanerPromise, dataPromise]);
            } catch (e) {
                console.error('Errore nel caricamento dati sensore:', e);
                this.overlay = false;
                return;
            }

            // Scarta la risposta se nel frattempo è stata avviata una richiesta più recente
            if (this.sensorDataRequestId !== requestId) return;

            // processo come before con res già disponibile
            {
                    // Normalizza risposta: backend può restituire array diretto o { Items: [...] } (es. DynamoDB)
                    const items = Array.isArray(res.data) ? res.data : (res.data && res.data.Items) ? res.data.Items : [];
                    
                    if (items.length == 0) {
                        this.applyEmptyChartsState(start, nextDay, time);
                        return;
                    }
                    try {
                    this.series_daytime = [];
                    this.chartOptions_daytime.xaxis.categories = [];
                    this.sensor_datas = items;
                    this.loading = false;
                    this.series_bin.length = 0;
                    var data_ = [];
                    var categoriesBin = [];
                    var dati = [];

                    // Supporta sia item.device_data (con received_at) sia item con received_at in cima, sia item con solo timestamp (es. eventi Lambda)
                    for (var i = items.length - 1; i >= 0; i--) {
                        var item = items[i];
                        var record = (item.device_data && item.device_data.received_at != null)
                            ? item.device_data
                            : (item.received_at != null ? item : (item.timestamp != null ? item : null));
                        if (record)
                            dati.push(record);
                    }
                    // Normalizza received_at (può essere timestamp numero o stringa ISO); supporta anche campo "timestamp" come alias
                    dati.forEach(function (r) {
                        if (!r) return;
                        var t = r.received_at != null ? r.received_at : r.timestamp;
                        if (t != null) r.received_at = this.normalizeReceivedAt(t);
                    }.bind(this));
                    
                    // Se dopo il filtraggio non ci sono dati validi, gestiamo come se non ci fossero dati
                    if (dati.length === 0) {
                        console.log('Nessun dato valido con timestamp trovato, costruisco la pagina con valori a 0');
                        this.applyEmptyChartsState(start, nextDay, time);
                        return;
                    }
                    
                    //var j = 0;
                    i = 0;
                    dati = dati.sort((a, b) => (a.received_at > b.received_at) ? 1 : -1)
                    //Recupero i valori per i punctual data
                    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                    const d = new Date();
                    let day = weekday[d.getDay()];
                    this.GiornoSettimana = day;
                    const lastReceived = dati[dati.length - 1].received_at;
                    this.OraSensore = formatTimeDisplay(lastReceived, this.$store.state.timezone || 'Europe/Rome');
                    this.DataSensore = formatDateDisplay(lastReceived, this.$store.state.timezone || 'Europe/Rome');
                    //var valore = 100-(((Number(dati[dati.length-1].doorCount.value) - this.minValue)* 100)/(this.maxValue - this.minValue)).toFixed(0);
                    // this.series_stacked.length = 0;
                    let valore_temp = 0;
                    var temp = dati[0].received_at.substr(0, 10);
                    var last = dati[dati.length - 1];
                    this.dayli = 0
                    this.rawDailyTrafficData = [];    // reset prima di ogni elaborazione
                    this.rawHourlyActivityData = []; // reset prima di ogni elaborazione

                    if (time == 0) {
                        // Aggregazione per giornata (3 giorni, 1 settimana, 2 settimane, 30 giorni)
                        // Crea un range completo di date
                        const getAllDatesInRange = (startStr, endStr) => {
                            const dates = [];
                            const startDateObj = new Date(startStr.substr(0, 10));
                            const endDateObj = new Date(endStr.substr(0, 10));
                            
                            let currentDate = new Date(startDateObj);
                            while (currentDate <= endDateObj) {
                                const dateStr = toBackendDate(currentDate);
                                dates.push(dateStr);
                                currentDate.setDate(currentDate.getDate() + 1);
                            }
                            return dates;
                        };
                        
                        const allDates = getAllDatesInRange(start, nextDay);
                        
                        // Inizializza tutti i giorni con 0
                        const dayValues = {};
                        allDates.forEach(date => {
                            dayValues[date] = 0;
                        });
                        
                        // Popola i dati esistenti
                        dati.forEach(el => {
                            var valore = this.getTrafficValue(el);
                            
                            // NON applicare l'aggiustamento Door Counter qui, lo facciamo dopo l'aggregazione
                            // altrimenti valori singoli come 1 diventano 0 (floor(1/2) = 0)
                            
                            // Normalizza il formato della data
                            var currentDay = el.received_at.substr(0, 10).replace(/\./g, '-');
                            
                            if (dayValues[currentDay] !== undefined) {
                                dayValues[currentDay] += valore;
                            }
                        });
                        
                        // Crea gli array per il grafico con tutti i giorni
                        // Applica l'aggiustamento Door Counter DOPO l'aggregazione
                        allDates.forEach(date => {
                            categoriesBin.push(date);
                            data_.push(this.applyDoorCounterAdjustment(dayValues[date]));
                        });
                        
                        // Salva dati grezzi giornalieri per ricalcolo KPI lato client con filtro weekend
                        this.rawDailyTrafficData = categoriesBin.map((date, i) => ({ date, traffic: data_[i] || 0 }));

                        // Calcola ore attive reali per giorno: conta le ore distinte con traffico > 0
                        const dailyActiveHoursMap = {};
                        allDates.forEach(date => { dailyActiveHoursMap[date] = new Set(); });
                        dati.forEach(el => {
                            if (this.getTrafficValue(el) > 0) {
                                const day = el.received_at.substr(0, 10).replace(/\./g, '-');
                                const hour = el.received_at.substr(11, 2);
                                if (dailyActiveHoursMap[day] !== undefined) {
                                    dailyActiveHoursMap[day].add(hour);
                                }
                            }
                        });
                        this.rawHourlyActivityData = allDates.map(date => ({
                            date,
                            activeHours: dailyActiveHoursMap[date].size
                        }));

                        // Processa i dati per il grafico daytime (mattina/pomeriggio)
                        this.ProcessDaytimeData(dati, start, nextDay, time);
                        // Processa i dati per il grafico a 4 ore
                        this.ProcessFourHourlyData(dati, start, nextDay, time);
                        // Processa i dati per il grafico alert
                        this.ProcessAlertData(dati, start, nextDay, time);
                    }
                    else {
                        // Processa i dati per il grafico daytime anche per aggregazione oraria (4 ore o 1 giorno)
                        this.ProcessDaytimeData(dati, start, nextDay, time);
                        // Processa i dati per il grafico a 4 ore anche per aggregazione oraria
                        this.ProcessFourHourlyData(dati, start, nextDay, time);
                        // Processa i dati per il grafico alert anche per aggregazione oraria
                        this.ProcessAlertData(dati, start, nextDay, time);
                        // Processa i dati per il grafico timeline solo per aggregazione oraria
                        this.ProcessTimelineData(dati, start, nextDay);
                        
                        // Aggregazione per ora (4 ore o 1 giorno) - senza minuti e secondi
                        temp = dati[0].received_at.substr(0, 10) + " " + dati[0].received_at.substr(11, 2); // Data + ora
                        dati.forEach(el => {
                            var valore = this.getTrafficValue(el);
                            
                            // NON applicare l'aggiustamento Door Counter qui, lo facciamo dopo l'aggregazione
                            
                            var currentHour = el.received_at.substr(0, 10) + " " + el.received_at.substr(11, 2);
                            
                            // Se è la stessa ora, accumula
                            if (currentHour == temp) {
                                valore_temp += valore;
                            } else {
                                // Nuova ora: salva i dati dell'ora precedente
                                // Applica l'aggiustamento Door Counter al valore aggregato
                                if (valore_temp > 0 || categoriesBin.length > 0 || el != dati[0]) {
                                    categoriesBin.push(temp.substr(0, 10) + " " + temp.substr(11, 2) + ":00");
                                    data_.push(this.applyDoorCounterAdjustment(valore_temp));
                                    this.dayli += this.applyDoorCounterAdjustment(valore_temp);
                                }
                                temp = currentHour;
                                valore_temp = valore;
                            }
                            
                            // Se è l'ultimo elemento, aggiungi i dati accumulati
                            if (el == last) {
                                categoriesBin.push(temp.substr(0, 10) + " " + temp.substr(11, 2) + ":00");
                                data_.push(this.applyDoorCounterAdjustment(valore_temp));
                                this.dayli += this.applyDoorCounterAdjustment(valore_temp);
                            }
                        })

                        // Per time==1 salva il totale della giornata come singola voce
                        const totalDay = data_.reduce((acc, v) => acc + (v || 0), 0);
                        this.rawDailyTrafficData = [{ date: start.substr(0, 10), traffic: totalDay }];

                        // Conta le ore reali con traffico > 0 (data_ contiene valori orari aggregati)
                        const activeHoursToday = data_.filter(v => (v || 0) > 0).length;
                        this.rawHourlyActivityData = [{ date: start.substr(0, 10), activeHours: activeHoursToday }];
                    }

                    //   if(time == 0){
                    //     if(dati.length > 50){
                    //         if(j==15 ){
                    //             this.chartOptions_bin.xaxis.categories.push(el.received_at.substr(8,2) + "-" + el.received_at.substr(11,5));
                    //             j = 1;
                    //         }
                    //         else{
                    //             this.chartOptions_bin.xaxis.categories.push("");
                    //             j++;
                    //         }
                    //         }
                    //     else{
                    //         this.chartOptions_bin.xaxis.categories.push(el.received_at.substr(8,2) + "-" + el.received_at.substr(11,5));
                    //             j = 1;
                    //     }
                    //   }
                    // if(time == 1){
                    //     if(dati.length > 30){
                    //         if(j==3){
                    //             this.chartOptions_bin.xaxis.categories.push(el.received_at.substr(8,2) + "-" + el.received_at.substr(11,5));
                    //             j = 1;
                    //         }
                    //         else{
                    //             this.chartOptions_bin.xaxis.categories.push("");
                    //             j++;
                    //         }
                    //     }
                    //     else{
                    //         this.chartOptions_bin.xaxis.categories.push(el.received_at.substr(8,2) + "-" + el.received_at.substr(11,5));
                    //             j = 1;
                    //     }
                    // }
                    const columnWidthVal = (() => {
                        const n = categoriesBin.length;
                        if (n <= 1) return '5%';
                        if (n <= 3) return '15%';
                        if (n <= 7) return '30%';
                        if (n <= 14) return '55%';
                        return '70%';
                    })();
                    const maxVal = data_.length > 0 ? Math.max(...data_) : 0;
                    this.chartOptions_bin = {
                        ...this.chartOptions_bin,
                        xaxis: {
                            ...this.chartOptions_bin.xaxis,
                            categories: categoriesBin.slice(),
                        },
                        yaxis: {
                            ...this.chartOptions_bin.yaxis,
                            min: 0,
                            max: maxVal === 0 ? 2 : undefined,
                            tickAmount: maxVal === 0 ? 2 : undefined,
                        },
                        plotOptions: {
                            ...this.chartOptions_bin.plotOptions,
                            bar: {
                                ...this.chartOptions_bin.plotOptions.bar,
                                columnWidth: columnWidthVal,
                            },
                        },
                    };
                    this.series_dispenser = [{ data: data_.slice(), name: this.sensor_name }];
                    
                    this.$nextTick(() => {
                        this.keyStacked++;
                        // Non chiamare updateAllChartSubtitles() qui: sostituisce chartOptions_bin e può azzerare le categorie.
                        if (this.currentStartDate && this.currentEndDate) {
                            this.$set(this.chartOptions_bin, 'subtitle', getChartSubtitleConfig(
                                this.currentStartDate,
                                this.currentEndDate,
                                this.$i18n.locale || 'en'
                            ));
                        }
                        this.applyChartsTimezone();
                        this.overlay = false;
                        this.visualizza_dati = true;
                    });
                    
                    // Calcola average daily traffic
                    if (data_.length > 0) {
                        const sum = data_.reduce((acc, val) => acc + val, 0);
                        
                        if (time == 0) {
                            // Aggregazione giornaliera: calcola la media tra i giorni
                            this.averageDailyTraffic = Math.round(sum / data_.length);
                        } else if (time == 1) {
                            // Aggregazione oraria (1 giorno): il totale è il traffico del giorno
                            this.averageDailyTraffic = Math.round(sum);
                        }
                    }
                    this.computeAverageDailyAlertsPeriod(start, nextDay);
                    
                    } catch (err) {
                        console.error('GetSensorData elaborazione dati:', err);
                        this.applyEmptyChartsState(start, nextDay, time);
                    }
            }
        },
        GetDataStacked(days) {
            axios.post(this.$store.state.URL_STACKED, {
                sensor: this.sensor_unique,
                ndays: days
            }).
                then(res => {
                    this.rawStackedData = res.data || [];
                    this.buildStackedCharts();
                })
                .catch(err => {
                    console.error('GetDataStacked errore:', err);
                })
        },
        buildStackedCharts() {
            const records = this.includeWeekends
                ? this.rawStackedData
                : this.rawStackedData.filter(el => {
                    const d = new Date(el.DataRegistrazione);
                    return d.getDay() !== 0 && d.getDay() !== 6;
                  });
            const ore_vuoto = [];
            const categories = [];
            const v_med = [];
            records.forEach(el => {
                categories.push(el.DataRegistrazione);
                ore_vuoto.push(el.OreVuoto);
                v_med.push(el.Media);
            });
            this.series_bar = [{ name: 'Full', data: ore_vuoto }];
            this.series_stacked = [{ name: 'Media valore', data: v_med }];
            this.chartOptions_stacked = { ...this.chartOptions_stacked, xaxis: { ...this.chartOptions_stacked.xaxis, categories } };
            this.chartOptions_bar = { ...this.chartOptions_bar, xaxis: { ...this.chartOptions_bar.xaxis, categories } };
            this.keyStacked += 1;
            this.keyBar += 1;
        },
        computeAverageDailyAlertsPeriod(start, nextDay) {
            if (!this.sensorAlerts || this.sensorAlerts.length === 0) {
                this.averageDailyAlertsPeriod = 0;
                return;
            }
            const startDate = new Date(start.replace(' ', 'T').substr(0, 19));
            const endDate = new Date(nextDay.replace(' ', 'T').substr(0, 19));
            const numDays = (endDate - startDate) / (1000 * 60 * 60 * 24);
            if (numDays <= 0) {
                this.averageDailyAlertsPeriod = 0;
                return;
            }
            let count = 0;
            this.sensorAlerts.forEach(alert => {
                const alertDate = new Date(alert.Timestamp);
                if (alertDate >= startDate && alertDate <= endDate) {
                    count++;
                }
            });
            this.averageDailyAlertsPeriod = count / numDays;
        },
        ProcessDaytimeData(dati, startDate, endDate, time = 0) {
            this.series_daytime = [];
            this.chartOptions_daytime.xaxis.categories = [];
            
            // Crea un range completo di date tra start e end
            const getAllDatesInRange = (start, end) => {
                const dates = [];
                const startDateObj = new Date(start.substr(0, 10));
                const endDateObj = new Date(end.substr(0, 10));
                
                let currentDate = new Date(startDateObj);
                while (currentDate <= endDateObj) {
                    const dateStr = toBackendDate(currentDate);
                    dates.push(dateStr);
                    currentDate.setDate(currentDate.getDate() + 1);
                }
                return dates;
            };
            
            const allDates = getAllDatesInRange(startDate, endDate);
            const morningData = [];
            const afternoonData = [];

            if (time === 1) {
                // Per time=1 (giornata singola): aggrega per ora, applica floor per ora,
                // poi somma i valori aggiustati in mattina/pomeriggio.
                // Stessa granularità del grafico principale → totali perfettamente coerenti.
                const dayData = {};
                allDates.forEach(date => { dayData[date] = { morning: 0, afternoon: 0 }; });

                const hourlyRaw = {};
                if (dati && dati.length > 0) {
                    dati.forEach(el => {
                        let valore = this.getTrafficValue(el);
                        if (valore > 0) {
                            const timestamp = el.received_at;
                            const date = timestamp.substr(0, 10).replace(/\./g, '-');
                            const hour = parseInt(timestamp.substr(11, 2));
                            if (dayData[date] !== undefined && hour >= 0 && hour < 24) {
                                const key = `${date}|${hour}`;
                                hourlyRaw[key] = (hourlyRaw[key] || 0) + valore;
                            }
                        }
                    });
                }

                Object.entries(hourlyRaw).forEach(([key, rawSum]) => {
                    const sepIdx = key.lastIndexOf('|');
                    const date = key.substring(0, sepIdx);
                    const hour = parseInt(key.substring(sepIdx + 1));
                    if (dayData[date] !== undefined) {
                        const adjSum = this.applyDoorCounterAdjustment(rawSum);
                        if (hour < 12) dayData[date].morning += adjSum;
                        else dayData[date].afternoon += adjSum;
                    }
                });

                allDates.forEach(date => {
                    this.chartOptions_daytime.xaxis.categories.push(date);
                    morningData.push(dayData[date].morning);
                    afternoonData.push(dayData[date].afternoon);
                });
            } else {
                // Per time=0 (multi-giorno): aggrega per giorno, applica floor al totale
                // giornaliero e distribuisce proporzionalmente ai bucket mattina/pomeriggio.
                const dayData = {};
                allDates.forEach(date => { dayData[date] = { morning: 0, afternoon: 0 }; });

                if (dati && dati.length > 0) {
                    dati.forEach(el => {
                        let valore = this.getTrafficValue(el);
                        if (valore > 0) {
                            const timestamp = el.received_at;
                            const date = timestamp.substr(0, 10).replace(/\./g, '-');
                            const hour = parseInt(timestamp.substr(11, 2));
                            if (dayData[date]) {
                                if (hour >= 0 && hour < 12) dayData[date].morning += valore;
                                else if (hour >= 12 && hour < 24) dayData[date].afternoon += valore;
                            }
                        }
                    });
                }

                allDates.forEach(date => {
                    this.chartOptions_daytime.xaxis.categories.push(date);
                    const rawDayBuckets = [dayData[date].morning, dayData[date].afternoon];
                    const adjDayTotal = this.applyDoorCounterAdjustment(rawDayBuckets[0] + rawDayBuckets[1]);
                    const [adjMorning, adjAfternoon] = this.distributeProportionally(adjDayTotal, rawDayBuckets);
                    morningData.push(adjMorning);
                    afternoonData.push(adjAfternoon);
                });
            }
            
            // Aggiorna le traduzioni per il grafico
            const eventsLabel = this.$t('washroomFrequency.events');
            this.chartOptions_daytime.tooltip = {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (val, { dataPointIndex, w }) {
                        const series = w.config.series;
                        let total = 0;
                        series.forEach(s => {
                            total += s.data[dataPointIndex] || 0;
                        });
                        const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                        return val + " " + eventsLabel + " (" + percentage + "%)";
                    }
                }
            };
            
            this.series_daytime = [
                { name: this.$t('washroomFrequency.morning'), data: morningData },
                { name: this.$t('washroomFrequency.afternoon'), data: afternoonData }
            ];
            
            // Adatta dinamicamente la larghezza delle colonne in base al numero di giorni
            const numDays = allDates.length;
            let columnWidth = '70%'; // Default per molti giorni
            
            if (numDays <= 1) {
                columnWidth = '8%'; // Molto stretto per 1 giorno
            } else if (numDays <= 3) {
                columnWidth = '20%'; // Stretto per 2-3 giorni
            } else if (numDays <= 7) {
                columnWidth = '40%'; // Medio per 4-7 giorni
            } else if (numDays <= 14) {
                columnWidth = '60%'; // Più largo per 8-14 giorni
            }
            
            this.chartOptions_daytime.plotOptions.bar.columnWidth = columnWidth;
            
            this.keyDaytime++;
            this.updateAllChartSubtitles();
        },

        ProcessFourHourlyData(dati, startDate, endDate, time = 0) {
            this.series_fourhourly = [];
            this.chartOptions_fourhourly.xaxis.categories = [];
            
            // Crea un range completo di date tra start e end
            const getAllDatesInRange = (start, end) => {
                const dates = [];
                const startDateObj = new Date(start.substr(0, 10));
                const endDateObj = new Date(end.substr(0, 10));
                
                let currentDate = new Date(startDateObj);
                while (currentDate <= endDateObj) {
                    const dateStr = toBackendDate(currentDate);
                    dates.push(dateStr);
                    currentDate.setDate(currentDate.getDate() + 1);
                }
                return dates;
            };
            
            const allDates = getAllDatesInRange(startDate, endDate);
            this.rawFourhourlyCategories = allDates.slice();
            const slot1Data = [];
            const slot2Data = [];
            const slot3Data = [];
            const slot4Data = [];
            const slot5Data = [];
            const slot6Data = [];

            if (time === 1) {
                // Per time=1 (giornata singola): aggrega per ora, applica floor per ora,
                // poi somma i valori aggiustati nelle 6 fasce da 4 ore.
                // Stessa granularità del grafico principale → totali perfettamente coerenti.
                const dayData = {};
                allDates.forEach(date => {
                    dayData[date] = { slot1: 0, slot2: 0, slot3: 0, slot4: 0, slot5: 0, slot6: 0 };
                });

                const hourlyRaw = {};
                if (dati && dati.length > 0) {
                    dati.forEach(el => {
                        let valore = this.getTrafficValue(el);
                        if (valore > 0) {
                            const timestamp = el.received_at;
                            const date = timestamp.substr(0, 10).replace(/\./g, '-');
                            const hour = parseInt(timestamp.substr(11, 2));
                            if (dayData[date] !== undefined && hour >= 0 && hour < 24) {
                                const key = `${date}|${hour}`;
                                hourlyRaw[key] = (hourlyRaw[key] || 0) + valore;
                            }
                        }
                    });
                }

                Object.entries(hourlyRaw).forEach(([key, rawSum]) => {
                    const sepIdx = key.lastIndexOf('|');
                    const date = key.substring(0, sepIdx);
                    const hour = parseInt(key.substring(sepIdx + 1));
                    if (dayData[date] !== undefined) {
                        const adjSum = this.applyDoorCounterAdjustment(rawSum);
                        if (hour < 4) dayData[date].slot1 += adjSum;
                        else if (hour < 8) dayData[date].slot2 += adjSum;
                        else if (hour < 12) dayData[date].slot3 += adjSum;
                        else if (hour < 16) dayData[date].slot4 += adjSum;
                        else if (hour < 20) dayData[date].slot5 += adjSum;
                        else dayData[date].slot6 += adjSum;
                    }
                });

                allDates.forEach(date => {
                    this.chartOptions_fourhourly.xaxis.categories.push(date);
                    slot1Data.push(dayData[date].slot1);
                    slot2Data.push(dayData[date].slot2);
                    slot3Data.push(dayData[date].slot3);
                    slot4Data.push(dayData[date].slot4);
                    slot5Data.push(dayData[date].slot5);
                    slot6Data.push(dayData[date].slot6);
                });
            } else {
                // Per time=0 (multi-giorno): aggrega per giorno, applica floor al totale
                // giornaliero e distribuisce proporzionalmente alle 6 fasce.
                const dayData = {};
                allDates.forEach(date => {
                    dayData[date] = { slot1: 0, slot2: 0, slot3: 0, slot4: 0, slot5: 0, slot6: 0 };
                });

                if (dati && dati.length > 0) {
                    dati.forEach(el => {
                        let valore = this.getTrafficValue(el);
                        if (valore > 0) {
                            const timestamp = el.received_at;
                            const date = timestamp.substr(0, 10).replace(/\./g, '-');
                            const hour = parseInt(timestamp.substr(11, 2));
                            if (dayData[date]) {
                                if (hour >= 0 && hour < 4) dayData[date].slot1 += valore;
                                else if (hour >= 4 && hour < 8) dayData[date].slot2 += valore;
                                else if (hour >= 8 && hour < 12) dayData[date].slot3 += valore;
                                else if (hour >= 12 && hour < 16) dayData[date].slot4 += valore;
                                else if (hour >= 16 && hour < 20) dayData[date].slot5 += valore;
                                else if (hour >= 20 && hour < 24) dayData[date].slot6 += valore;
                            }
                        }
                    });
                }

                allDates.forEach(date => {
                    this.chartOptions_fourhourly.xaxis.categories.push(date);
                    const rawSlots = [
                        dayData[date].slot1, dayData[date].slot2, dayData[date].slot3,
                        dayData[date].slot4, dayData[date].slot5, dayData[date].slot6,
                    ];
                    const adjSlotTotal = this.applyDoorCounterAdjustment(rawSlots.reduce((a, b) => a + b, 0));
                    const [adj1, adj2, adj3, adj4, adj5, adj6] = this.distributeProportionally(adjSlotTotal, rawSlots);
                    slot1Data.push(adj1);
                    slot2Data.push(adj2);
                    slot3Data.push(adj3);
                    slot4Data.push(adj4);
                    slot5Data.push(adj5);
                    slot6Data.push(adj6);
                });
            }
            
            // Aggiorna le traduzioni per il grafico
            const eventsLabel = this.$t('washroomFrequency.events');
            this.chartOptions_fourhourly.tooltip = {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (val, { dataPointIndex, w }) {
                        const series = w.config.series;
                        let total = 0;
                        series.forEach(s => {
                            total += s.data[dataPointIndex] || 0;
                        });
                        const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                        return val + " " + eventsLabel + " (" + percentage + "%)";
                    }
                }
            };
            
            // Determina il prefisso in base alla lingua corrente
            const locale = this.$i18n.locale;
            let prefix = 'f'; // default italiano
            if (locale === 'en') {
                prefix = 'b';
            } else if (locale === 'de') {
                prefix = 'z';
            }
            
            this.series_fourhourly = [
                { name: this.$t(`washroomFrequency.${prefix}1`), data: slot1Data },
                { name: this.$t(`washroomFrequency.${prefix}2`), data: slot2Data },
                { name: this.$t(`washroomFrequency.${prefix}3`), data: slot3Data },
                { name: this.$t(`washroomFrequency.${prefix}4`), data: slot4Data },
                { name: this.$t(`washroomFrequency.${prefix}5`), data: slot5Data },
                { name: this.$t(`washroomFrequency.${prefix}6`), data: slot6Data }
            ];
            
            // Adatta dinamicamente la larghezza delle colonne in base al numero di giorni
            const numDays = allDates.length;
            let columnWidth = '70%'; // Default per molti giorni
            
            if (numDays <= 1) {
                columnWidth = '8%'; // Molto stretto per 1 giorno
            } else if (numDays <= 3) {
                columnWidth = '20%'; // Stretto per 2-3 giorni
            } else if (numDays <= 7) {
                columnWidth = '40%'; // Medio per 4-7 giorni
            } else if (numDays <= 14) {
                columnWidth = '60%'; // Più largo per 8-14 giorni
            }
            
            this.chartOptions_fourhourly.plotOptions.bar.columnWidth = columnWidth;
            
            this.keyFourHourly++;
            this.updateAllChartSubtitles();
        },

        ProcessAlertData(dati, startDate, endDate, time = 0) {
            this.series_alert = [];
            this.chartOptions_alert.xaxis.categories = [];
            
            if (time == 0) {
                // Aggregazione giornaliera
                const getAllDatesInRange = (start, end) => {
                    const dates = [];
                    const startDateObj = new Date(start.substr(0, 10));
                    const endDateObj = new Date(end.substr(0, 10));
                    
                    let currentDate = new Date(startDateObj);
                    while (currentDate <= endDateObj) {
                        const dateStr = toBackendDate(currentDate);
                        dates.push(dateStr);
                        currentDate.setDate(currentDate.getDate() + 1);
                    }
                    return dates;
                };
                
                const allDates = getAllDatesInRange(startDate, endDate);
                
                // Inizializza tutti i giorni con valori 0
                const dayData = {};
                allDates.forEach(date => {
                    dayData[date] = { withoutAlert: 0, duringAlert: 0 };
                });
                
                // Popola i dati esistenti
                if (dati && dati.length > 0) {
                    dati.forEach((el) => {
                        let valore = this.getTrafficValue(el);
                        // NON applicare l'aggiustamento Door Counter qui sui valori singoli
                        if (valore > 0) {
                            const timestamp = el.received_at;
                            const date = timestamp.substr(0, 10).replace(/\./g, '-');
                            
                            // Assicurati che la data esista in dayData
                            if (dayData[date]) {
                                // Verifica se l'evento è durante un alert
                                if (this.isDuringAlert(timestamp)) {
                                    dayData[date].duringAlert += valore;
                                } else {
                                    dayData[date].withoutAlert += valore;
                                }
                            }
                        }
                    });
                }
                
                // Crea le serie dati per tutti i giorni
                // Applica l'aggiustamento Door Counter DOPO l'aggregazione
                const withoutAlertData = [];
                const duringAlertData = [];
                allDates.forEach(date => {
                    this.chartOptions_alert.xaxis.categories.push(date);
                    const rawAlertDay = [dayData[date].withoutAlert, dayData[date].duringAlert];
                    const adjAlertDay = this.applyDoorCounterAdjustment(rawAlertDay[0] + rawAlertDay[1]);
                    const [adjWithoutDay, adjDuringDay] = this.distributeProportionally(adjAlertDay, rawAlertDay);
                    withoutAlertData.push(adjWithoutDay);
                    duringAlertData.push(adjDuringDay);
                });
                
                this.series_alert = [
                    { name: this.$t('washroomFrequency.normalTraffic'), data: withoutAlertData },
                    { name: this.$t('washroomFrequency.trafficDuringAlert'), data: duringAlertData }
                ];
                
                // Adatta dinamicamente la larghezza delle colonne in base al numero di giorni
                const numDays = allDates.length;
                let columnWidth = '70%';
                
                if (numDays <= 1) {
                    columnWidth = '8%';
                } else if (numDays <= 3) {
                    columnWidth = '20%';
                } else if (numDays <= 7) {
                    columnWidth = '40%';
                } else if (numDays <= 14) {
                    columnWidth = '60%';
                }
                
                this.chartOptions_alert.plotOptions.bar.columnWidth = columnWidth;
                
            } else {
                // Aggregazione oraria (per time == 1, es. 1 giorno)
                // Crea tutte le ore nel periodo
                const getAllHoursInRange = (start, end) => {
                    const hours = [];
                    const startDateObj = new Date(start.substr(0, 19));
                    const endDateObj = new Date(end.substr(0, 19));
                    
                    let currentHour = new Date(startDateObj);
                    currentHour.setMinutes(0, 0, 0); // Imposta a inizio ora
                    
                    while (currentHour <= endDateObj) {
                        // Usa la stessa estrazione dell'ora dei timestamp degli eventi (grezzo,
                        // senza conversione timezone) per garantire che le chiavi combacino.
                        const dateStr = toBackendDate(currentHour);
                        const hh = String(currentHour.getHours()).padStart(2, '0');
                        hours.push(`${dateStr} ${hh}:00`);
                        currentHour.setHours(currentHour.getHours() + 1);
                    }
                    return hours;
                };
                
                const allHours = getAllHoursInRange(startDate, endDate);
                
                // Inizializza tutte le ore con valori 0
                const hourData = {};
                allHours.forEach(hour => {
                    hourData[hour] = { withoutAlert: 0, duringAlert: 0 };
                });
                
                // Popola i dati esistenti
                if (dati && dati.length > 0) {
                    dati.forEach((el) => {
                        let valore = this.getTrafficValue(el);
                        // NON applicare l'aggiustamento Door Counter qui sui valori singoli
                        if (valore > 0) {
                            const timestamp = el.received_at;
                            // Normalizza il formato: sostituisce i punti con trattini
                            const hour = timestamp.substr(0, 13).replace(/\./g, '-').replace('T', ' ') + ':00';
                            
                            // Assicurati che l'ora esista in hourData
                            if (hourData[hour]) {
                                // Verifica se l'evento è durante un alert
                                if (this.isDuringAlert(timestamp)) {
                                    hourData[hour].duringAlert += valore;
                                } else {
                                    hourData[hour].withoutAlert += valore;
                                }
                            }
                        }
                    });
                }
                
                // Crea le serie dati per tutte le ore
                // Applica l'aggiustamento Door Counter DOPO l'aggregazione
                const withoutAlertData = [];
                const duringAlertData = [];
                allHours.forEach(hour => {
                    this.chartOptions_alert.xaxis.categories.push(hour);
                    const rawAlertHour = [hourData[hour].withoutAlert, hourData[hour].duringAlert];
                    const adjAlertHour = this.applyDoorCounterAdjustment(rawAlertHour[0] + rawAlertHour[1]);
                    const [adjWithoutH, adjDuringH] = this.distributeProportionally(adjAlertHour, rawAlertHour);
                    withoutAlertData.push(adjWithoutH);
                    duringAlertData.push(adjDuringH);
                });
                
                this.series_alert = [
                    { name: this.$t('washroomFrequency.normalTraffic'), data: withoutAlertData },
                    { name: this.$t('washroomFrequency.trafficDuringAlert'), data: duringAlertData }
                ];
                
                // Adatta la larghezza delle colonne per visualizzazione oraria
                const numHours = allHours.length;
                let columnWidth = '70%';
                
                if (numHours <= 4) {
                    columnWidth = '15%';
                } else if (numHours <= 12) {
                    columnWidth = '40%';
                } else if (numHours <= 24) {
                    columnWidth = '60%';
                }
                
                this.chartOptions_alert.plotOptions.bar.columnWidth = columnWidth;
            }
            
            this.keyAlert++;
            this.updateAllChartSubtitles();
        },

        ProcessTimelineData(dati, startDate, endDate) {
            console.log('[Timeline] ProcessTimelineData chiamato:', { startDate, endDate, nDati: dati ? dati.length : 0, showTimelineGraph: this.showTimelineGraph });
            // Salva i parametri per il re-render al cambio lingua
            this.lastTimelineData = dati;
            this.lastTimelineStart = startDate;
            this.lastTimelineEnd = endDate;
            
            this.series_timeline = [];
            this.chartOptions_timeline.annotations.xaxis = [];
            this.chartOptions_timeline.annotations.points = [];
            
            // Calcola i timestamp di inizio e fine del range
            const startDateObj = new Date(startDate.substr(0, 19));
            const endDateObj = new Date(endDate.substr(0, 19));
            console.log('[Timeline] startDateObj:', startDateObj, 'endDateObj:', endDateObj, 'validi:', !isNaN(startDateObj.getTime()), !isNaN(endDateObj.getTime()));
            
            // Crea una mappa oraria con tutti i valori (usa un oggetto per aggregare per ora)
            const hourlyData = {};
            
            // Inizializza tutte le ore con 0
            let currentHour = new Date(startDateObj);
            while (currentHour <= endDateObj) {
                const hourKey = currentHour.getTime();
                hourlyData[hourKey] = 0;
                currentHour.setHours(currentHour.getHours() + 1);
            }
            
            // Popola con i dati reali
            if (dati && dati.length > 0) {
                dati.forEach(el => {
                    let valore = this.getTrafficValue(el);
                    if (valore > 0) {
                        const timestamp = el.received_at;
                        const normalizedTimestamp = timestamp.replace(/\./g, '-').replace('T', ' ');
                        const eventDate = new Date(normalizedTimestamp);
                        const hourDate = new Date(eventDate);
                        hourDate.setMinutes(0, 0, 0);
                        const hourKey = hourDate.getTime();
                        if (hourlyData[hourKey] !== undefined) {
                            hourlyData[hourKey] += valore;
                        }
                    }
                });
            }
            
            // Converti la mappa in array ordinato
            // Applica l'aggiustamento Door Counter DOPO l'aggregazione
            const timelineData = Object.keys(hourlyData)
                .map(key => ({
                    x: parseInt(key, 10),
                    y: this.applyDoorCounterAdjustment(hourlyData[key])
                }))
                .sort((a, b) => a.x - b.x);
            
            this.series_timeline = [{
                name: this.$t('washroomFrequency.events'),
                data: timelineData
            }];
            console.log('[Timeline] series_timeline impostato:', this.series_timeline[0]?.data?.length, 'punti; showTimelineGraph:', this.showTimelineGraph);
            
            this.chartOptions_timeline.xaxis.min = startDateObj.getTime();
            this.chartOptions_timeline.xaxis.max = endDateObj.getTime();
            
            // Annotazioni per gli alert
            if (this.sensorAlerts && this.sensorAlerts.length > 0) {
                this.sensorAlerts.forEach((alert) => {
                    try {
                        // Se gestito=1 ma Timestamp_Gestione non è valido (0000-00-00), salta l'alert
                        if (alert.Gestito == 1) {
                            const tg = String(alert.Timestamp_Gestione || '').trim();
                            if (!tg || tg.indexOf('0000-00-00') === 0) return;
                        }
                    const alertStart = new Date(alert.Timestamp);
                    const isAlertInRange = alertStart >= startDateObj && alertStart <= endDateObj;
                    
                    if (!isAlertInRange && alertStart < startDateObj) {
                        if (alert.Gestito == 1) {
                            const tsGest = alert.Timestamp_Gestione;
                            if (tsGest && String(tsGest).trim().indexOf('0000-00-00') !== 0) {
                                const alertEnd = new Date(tsGest);
                                if (alertEnd && alertEnd >= startDateObj && alertEnd <= endDateObj) {
                                    const cleanTime = formatTimeDisplay(alertEnd, this.$store.state.timezone || 'Europe/Rome');
                                    this.chartOptions_timeline.annotations.xaxis.push({
                                        x: startDateObj.getTime(),
                                        x2: alertEnd.getTime(),
                                        fillColor: '#ff914d',
                                        opacity: 0.3,
                                        label: { borderColor: 'transparent', style: { color: '#ff914d', background: 'transparent', fontSize: '9px', fontWeight: 400 }, text: '', orientation: 'horizontal', position: 'top' }
                                    });
                                    this.chartOptions_timeline.annotations.xaxis.push({
                                        x: alertEnd.getTime(),
                                        borderColor: '#009CAB',
                                        strokeDashArray: 5,
                                        borderWidth: 2
                                    });
                                    this.chartOptions_timeline.annotations.points.push({
                                        x: alertEnd.getTime(),
                                        y: 0,
                                        marker: { size: 6, fillColor: '#009CAB', strokeColor: '#fff', strokeWidth: 2 },
                                        label: { borderColor: '#009CAB', style: { color: '#fff', background: '#009CAB', fontSize: '10px', fontWeight: 600 }, text: '🧹 ' + this.$t('washroomFrequency.cleaned') + ' ' + cleanTime, orientation: 'horizontal', offsetY: 0 }
                                    });
                                } else if (alertEnd && alertEnd > endDateObj) {
                                    this.chartOptions_timeline.annotations.xaxis.push({
                                        x: startDateObj.getTime(),
                                        x2: endDateObj.getTime(),
                                        fillColor: '#ff914d',
                                        opacity: 0.3,
                                        label: { borderColor: 'transparent', style: { color: '#ff914d', background: 'transparent', fontSize: '9px', fontWeight: 400 }, text: '', orientation: 'horizontal', position: 'top' }
                                    });
                                }
                            }
                        } else {
                            const now = new Date();
                            const colorUntil = now < endDateObj ? now : endDateObj;
                            this.chartOptions_timeline.annotations.xaxis.push({
                                x: startDateObj.getTime(),
                                x2: colorUntil.getTime(),
                                fillColor: '#ff914d',
                                opacity: 0.3,
                                label: { borderColor: 'transparent', style: { color: '#ff914d', background: 'transparent', fontSize: '9px', fontWeight: 400 }, text: '', orientation: 'horizontal', position: 'top' }
                            });
                        }
                    }
                    
                    if (isAlertInRange) {
                        const alertTime = formatTimeDisplay(alertStart, this.$store.state.timezone || 'Europe/Rome');
                        this.chartOptions_timeline.annotations.xaxis.push({
                            x: alertStart.getTime(),
                            borderColor: '#ff914d',
                            strokeDashArray: 5,
                            borderWidth: 2,
                            label: { borderColor: '#ff914d', style: { color: '#fff', background: '#ff914d', fontSize: '10px', fontWeight: 600 }, text: '⚠️ ' + this.$t('washroomFrequency.alert') + ' ' + alertTime, orientation: 'horizontal', position: 'top' }
                        });
                        if (alert.Gestito == 1) {
                            const tsGest = alert.Timestamp_Gestione;
                            if (tsGest && String(tsGest).trim().indexOf('0000-00-00') !== 0) {
                                const alertEnd = new Date(tsGest);
                                if (alertEnd) {
                                    if (alertEnd >= startDateObj && alertEnd <= endDateObj) {
                                        const cleanTime = formatTimeDisplay(alertEnd, this.$store.state.timezone || 'Europe/Rome');
                                        this.chartOptions_timeline.annotations.xaxis.push({
                                            x: alertStart.getTime(),
                                            x2: alertEnd.getTime(),
                                            fillColor: '#ff914d',
                                            opacity: 0.3,
                                            label: { borderColor: 'transparent', style: { color: '#ff914d', background: 'transparent', fontSize: '9px', fontWeight: 400 }, text: '', orientation: 'horizontal', position: 'top' }
                                        });
                                        this.chartOptions_timeline.annotations.xaxis.push({
                                            x: alertEnd.getTime(),
                                            borderColor: '#009CAB',
                                            strokeDashArray: 5,
                                            borderWidth: 2
                                        });
                                        this.chartOptions_timeline.annotations.points.push({
                                            x: alertEnd.getTime(),
                                            y: 0,
                                            marker: { size: 6, fillColor: '#009CAB', strokeColor: '#fff', strokeWidth: 2 },
                                            label: { borderColor: '#009CAB', style: { color: '#fff', background: '#009CAB', fontSize: '10px', fontWeight: 600 }, text: '🧹 ' + this.$t('washroomFrequency.cleaned') + ' ' + cleanTime, orientation: 'horizontal', offsetY: 0 }
                                        });
                                    } else if (alertEnd > endDateObj) {
                                        this.chartOptions_timeline.annotations.xaxis.push({
                                            x: alertStart.getTime(),
                                            x2: endDateObj.getTime(),
                                            fillColor: '#ff914d',
                                            opacity: 0.3,
                                            label: { borderColor: 'transparent', style: { color: '#ff914d', background: 'transparent', fontSize: '9px', fontWeight: 400 }, text: '', orientation: 'horizontal', position: 'top' }
                                        });
                                    }
                                }
                            }
                        } else {
                            const now = new Date();
                            const colorUntil = now < endDateObj ? now : endDateObj;
                            this.chartOptions_timeline.annotations.xaxis.push({
                                x: alertStart.getTime(),
                                x2: colorUntil.getTime(),
                                fillColor: '#ff914d',
                                opacity: 0.3,
                                label: { borderColor: 'transparent', style: { color: '#ff914d', background: 'transparent', fontSize: '9px', fontWeight: 400 }, text: '', orientation: 'horizontal', position: 'top' }
                            });
                        }
                    }
                    } catch (e) {
                        // Ignora alert malformato
                    }
                });
            }
            
            // Annotazioni per pulizie da CLEANER_SCAN
            if (this.cleanerScanEvents && this.cleanerScanEvents.length > 0) {
                this.cleanerScanEvents.forEach((event) => {
                    try {
                    const ts = event.typeSpecificProps?.timestamp || event.timestamp || event.createdAt;
                    const scanDate = ts ? this.parseDateSafe(String(ts)) : null;
                    if (!scanDate || scanDate < startDateObj || scanDate > endDateObj) return;
                    const cleanTimeStr = formatTimeDisplay(scanDate, this.$store.state.timezone || 'Europe/Rome');
                    this.chartOptions_timeline.annotations.xaxis.push({
                        x: scanDate.getTime(),
                        borderColor: '#009CAB',
                        strokeDashArray: 5,
                        borderWidth: 2
                    });
                    this.chartOptions_timeline.annotations.points.push({
                        x: scanDate.getTime(),
                        y: 0,
                        marker: { size: 6, fillColor: '#009CAB', strokeColor: '#fff', strokeWidth: 2 },
                        label: { borderColor: '#009CAB', style: { color: '#fff', background: '#009CAB', fontSize: '10px', fontWeight: 600 }, text: '🧹 ' + this.$t('washroomFrequency.cleaned') + ' ' + cleanTimeStr, orientation: 'horizontal', offsetY: 0 }
                    });
                    } catch (e) {
                        // Ignora evento malformato
                    }
                });
            }
            
            this.keyTimeline++;
            this.updateAllChartSubtitles();
        },
        
        handleImageError(event) {
            console.error('❌ Errore nel caricamento dell\'immagine del sensore:', {
                sensorName: this.sensor_name,
                imageUrl: event.target.src
            });
            
            // Nascondi l'immagine se fallisce il caricamento
            event.target.style.display = 'none';
        },
        
    },
}
</script>
<style scoped>
/* ── V2 Overview styles ─────────────────────────────────────────────────── */
.wfv2-container { background: #F5F7FB; min-height: 100vh; text-align: left; }
.wfv2-filter-bar { border-radius: 12px !important; border: 1px solid #e8eef6 !important; background: white !important; }
.wfv2-card { border-radius: 12px !important; border: 1px solid #e8eef6 !important; background: white !important; }
.wfv2-chart-card { border-radius: 12px !important; border: 1px solid #e8eef6 !important; background: white !important; }
.wfv2-overline { font-size: 11px; font-weight: 600; letter-spacing: 1.2px; color: #8899BB; text-transform: uppercase; }
.wfv2-badge { font-size: 10px !important; height: 20px !important; }
.wfv2-sensor-name { font-size: 1.7rem; font-weight: 700; color: #213A8F; line-height: 1.2; }
.wfv2-muted { color: #8899BB !important; }
.wfv2-info-tile { border-radius: 8px !important; border: 1px solid #e8eef6 !important; }
.wfv2-info-value { font-size: 0.78rem; font-weight: 700; color: #213A8F; margin-top: 2px; line-height: 1.3; }
.wfv2-level-pct { font-size: 2.8rem; font-weight: 700; color: #213A8F; line-height: 1; }
.wfv2-bar-wrapper { position: relative; padding-top: 22px; }
.wfv2-bar-threshold-label {
    position: absolute; top: 0; transform: translateX(-50%);
    background: white; border: 1px solid #FF9800; border-radius: 4px;
    padding: 1px 5px; font-size: 10px; color: #FF9800; white-space: nowrap; z-index: 1;
}
.wfv2-bar {
    height: 26px; background: #BFCCE4; border-radius: 13px;
    position: relative; overflow: visible;
}
.wfv2-bar-fill {
    height: 100%; border-radius: 13px; position: relative;
    background: linear-gradient(to right, #009CAB, #213A8F);
    transition: width 0.6s ease;
}
.wfv2-bar-fill-label {
    position: absolute; right: 10px; top: 50%;
    transform: translateY(-50%); color: white;
    font-weight: 700; font-size: 12px;
}
.wfv2-bar-marker {
    position: absolute; top: -4px; bottom: -4px;
    width: 3px; background: #FF9800; transform: translateX(-50%);
    border-radius: 2px;
}
.wfv2-legend { gap: 6px; flex-wrap: wrap; margin-top: 8px; }
.wfv2-legend-dot { width: 10px; height: 10px; border-radius: 50%; display: inline-block; margin-right: 4px; }
.wfv2-legend-line { display: inline-block; width: 3px; height: 14px; background: #FF9800; border-radius: 2px; margin-right: 4px; }
.wfv2-kpi-card {
  border: 1px solid #e8eef6 !important; border-radius: 12px !important;
  background: white; height: 100%; text-align: center;
  display: flex; flex-direction: column; align-items: center;
}
.wfv2-kpi-icon { margin-bottom: 6px; }
.wfv2-kpi-label { font-size: 11px; color: #8899BB; line-height: 1.3; min-height: 30px; }
.wfv2-kpi-value {
  font-size: 1.8rem; font-weight: 700; color: #213A8F;
  line-height: 1.1; margin: 4px 0;
  min-height: 44px; display: flex; align-items: center; justify-content: center;
  width: 100%;
}
.wfv2-kpi-value-sm { font-size: 1.1rem; }
.wfv2-kpi-sub { font-size: 11px; color: #8899BB; }

.miochart.apexcharts-bar-area:hover {
    fill: #213A8F !important;
}

.apexcharts-line-area:hover {
    fill: #213A8F !important;
}

.v-select__selection,
.v-select__selection--comma,
.v-select.v-text-field input {
    color: #213A8F !important;
}

.v-icon.v-incon {
    color: #213A8F !important;
}

#changeMyColor .v-text-field--outlined fieldset {
    border: #BFCCE4 1px solid !important;
}

.mt-4 mb-4 mr-4 ml-4 v-btn v-btn--text theme--light v-size--default {
    border: #213A8F 1px solid !important;
}
</style>